/**
 * Created by Christof Sander on 25.05.2016.
 */

// TODO: extract server only code!

// the Component variable has to be instantiated at runtime to prevent circle dependencies between the Component- and the utils-Class
var Component;
var componentUndefined = true;

// moment must be initialized with timezone and range
// NOTE: see utils.initMoment(...)
const moment = require('moment-timezone');
const MomenRange = require('moment-range');
var removeDiacritics = require('diacritics').remove;

var kebabCase = require('lodash.kebabcase');
var truncateStringByBytes = require('./utils.truncateStringByBytes');
const MomentRange = require("moment-range");
var getLength = Buffer.byteLength.bind(Buffer);


var SITEMAP_HEADER = '<?xml version="1.0" encoding="UTF-8"?><urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9" xmlns:xhtml="http://www.w3.org/1999/xhtml">';
var SITEMAP_FOOTER = '</urlset>';


// TODO: CLEANUP ACTION-CLASS vs PROMISE DEBUG STUFF
// var Action = require('../client/action');

// TODO: DEBUG CLEANUP START
var stats = {
	replaces: 0,
	merges: 0,
	simpleMerges: 0,
	refMerges: 0,
	forEaches: 0
};
// TODO: DEBUG CLEANUP END

// DEFAULT CONSTANTS FALLBACK
if(Number.MAX_SAFE_INTEGER === undefined) Number.MAX_SAFE_INTEGER = 4294967296;
if(Number.MIN_SAFE_INTEGER === undefined) Number.MIN_SAFE_INTEGER = -Number.MAX_SAFE_INTEGER + 2;

var DEFAULT_RENDERED_IMAGE_CODENAME = '__default';


/**
 * this is a static class used to collect common usage functions.
 * at the moment this class will be used in client-side code primarily to prevent the necessity of loading lodash-lib in client-side apps.
 *
 * @author  cs
 * @since   25.5.2016
 * @version 1.0
 */
const utils = {
	$: null,

	getStats: function(){
		return stats;
	},

	getComponentIDByIndex: function(index){
		return 'c_' + String(index).replace(/^-+/, '_');
	},



	///////////////////////////////////////////////
	///// STATUS HELPERS
	///////////////////////////////////////////////

	/**
	 * this function returns if the given element is empty or not
	 *
	 * @param   element
	 * @returns {boolean}
	 */
	isEmpty: function(element){
		return typeof(element) === 'undefined' || element === '' || element === null || element === 0 || element === false || (typeof(element) === 'object' && this.collectionSize(element) === 0);
	},

	/**
	 * this function returns if the given element is a function or not
	 *
	 * @param   element
	 * @returns {boolean}
	 */
	isFunction: function(element){
		return typeof(element) === 'function';
	},

	/**
	 * this function returns true if the given element is an array
	 *
	 * @param   element
	 * @returns {boolean}
	 */
	isArray: function(element){
		return Array.isArray(element);
	},

	/**
	 * this function returns true if the given element is an object
	 *
	 * @param   element
	 * @returns {boolean}
	 */
	isObject: function(element){
		return typeof(element) === 'object' && !Array.isArray(element);
	},

	/**
	 * this function returns true if the given element is an array or an object
	 *
	 * @param   element
	 * @returns {boolean}
	 */
	isCollection: function(element){
		return element !== null && typeof(element) === 'object' || Array.isArray(element);
	},

	/**
	 * this function returns true if the given element is a string
	 *
	 * @param   element
	 * @returns {boolean}
	 */
	isString: function(element){
		return typeof(element) === 'string';
	},

	/**
	 * this function returns true if the given element is a number
	 *
	 * @param   element
	 * @returns {boolean}
	 */
	isNumber: function(element){
		return typeof(element) === 'number';
	},

	/**
	 * this function is used to check if a equals b. in case of arrays or objects all elements will be checked recursive.
	 *
	 * @param a						data element to check for equality
	 * @param b						data element to check for equality
	 * @param isEqualCallback		if this function is defined it will be called with the following parameters in case of a found unEquality ([key], a, b).
	 * 								this function by return true for equal or false otherwise. this way you may define exceptions.
	 * @param callbackIsReady		boolean flag which is used by internal logic only. never set this flag from outside.
	 * @returns {boolean}			true if the elements are equal.
	 */
	isEqual: function(a, b, isEqualCallback, callbackIsReady){
		if(callbackIsReady === undefined) callbackIsReady = typeof isEqualCallback === 'function';

		if(!utils.isCollection(a)){
			if(a !== b){
				if(callbackIsReady) return !!isEqualCallback(undefined, a, b);
				return false;
			}
			return true;
		}
		if(!utils.isCollection(b)){
			if(callbackIsReady) return !!isEqualCallback(undefined, a, b);
			return false
		}

		var equal = true;
		var preventCallback = false;
		var i;
		var keys = {};
		var key;
		var data = [a, b];
		for(i = 0; i < 2; i++){
			for(key in data[i]){
				if(!keys[key]) {
					keys[key] = true;
					preventCallback = false;
					if(!utils.isCollection(a[key])){
						equal &= a[key] === b[key];
					} else if(!utils.isCollection(b[key])){
						equal = false;
					} else {
						preventCallback = true;
						equal &= utils.isEqual(a[key], b[key], isEqualCallback, callbackIsReady);
					}

					if(!equal){
						if(callbackIsReady && !preventCallback){
							if(!isEqualCallback(key, a[key], b[key])){
								return false;
							}
							equal = true;
						} else {
							return false;
						}
					}
				}
			}
		}

		return true;
	},

	/**
	 * returns the number of elements within a collection.
	 * if the given element is no collection ([] | {}) zero will be returned.
	 *
	 * @param   element
	 * @returns int
	 */
	collectionSize: function(element){
		if(Array.isArray(element)){
			return element.length || Object.keys(element).length; // there are special cases where invalid arrays (those using non-numeric indexes) should be recognized. those arrays have length-property = 0 but contain values.
		}
		else if(typeof(element) === 'object' && element !== null){
			return Object.keys(element).length;
		}

		return 0;
	},

	/**
	 * this function returns Object.values in a ES2015 compatible way.
	 *
	 * @param element		[] || {}
	 * @returns {[]}
	 */
	collectionValues: function(element){
		if(!element){
			return [];
		}
		if(Array.isArray(element)){
			return element;
		}
		if(typeof Object.values === 'function'){
			return Object.values(element);
		}

		var result = [];
		for(var e in element){
			result.push(element[e]);
		}
		return result;
	},

	/**
	 * this function returns the first argument which is set in the argument list
	 *
	 * @returns {*}
	 */
	first: function(){
		if(arguments.length > 0) return arguments[0];
		return;
	},



	///////////////////////////////////////////////
	///// COLLECTION OPERATIONS
	///////////////////////////////////////////////

	/**
	 * this function is similar than js-native index of with two essential difference:
	 *      this function uses == rather than === and
	 *      it works with objects
	 *
	 * @param       collection  	[] || {}
	 * @param       element     	element || function(){} => boolean
	 * @param       defaultValue    default: -1
	 * @returns     {number}    	defaultValue if not found and array index of found element otherwise
	 */
	indexOf: function(collection, element, defaultValue = -1){
		var elementIsFunction = typeof(element) === 'function';

		if(Array.isArray(collection)) {
			for (var i = 0; i < collection.length; i++) {
				if (elementIsFunction && element(collection[i], i)) return i;
				if (collection[i] == element) 						return i;
			}
		} else if(typeof(collection) === 'object' && collection !== null){
			var keys = Object.keys(collection);
			for (var i = 0; i < keys.length; i++) {
				if (elementIsFunction && element(collection[i], i)) return keys[i];
				if (collection[keys[i]] == element) 				return keys[i];
			}
		}
		return defaultValue;
	},

	/**
	 * this function is used to perform a well known forEach operation on arrays as well as objects like lodash does
	 *
	 * @param   collection        array | object
	 * @param   elementCallback   function
	 * @returns void
	 */
	forEach: function(collection, elementCallback){
		stats.forEaches++;

		if(typeof(elementCallback) === 'function' && !this.isEmpty(collection)){
			const keys = Object.keys(collection);
			const firstKey = keys[0];
			const lastKey = keys[keys.length - 1];
			for(let index in keys){
				const neighbours = {}
				if(index == index * 1){
					index = index * 1
					if(index > 0){
						neighbours.prev = {
							index: keys[index - 1],
							entry: collection[keys[index - 1]]
						}
					}
					if(index < keys.length - 1){
						neighbours.next = {
							index: keys[index + 1],
							entry: collection[keys[index + 1]]
						}
					}
				}
				if(elementCallback(collection[keys[index]], keys[index], keys[index] === firstKey, keys[index] === lastKey, neighbours) === false) break;
			}
		}
	},

	/**
	 * this function is used to perform a well known forEach operation on arrays as well as objects like lodash does.
	 * the only difference is that the list will be traversed backwards.
	 *
	 * @param   collection        array | object
	 * @param   elementCallback   function
	 * @returns void
	 */
	forEachReverse: function(collection, elementCallback){
		stats.forEaches++;

		if(typeof(elementCallback) === 'function' && !this.isEmpty(collection)){
			const keys = Object.keys(collection);
			const firstKey = keys[0];
			const lastKey = keys[keys.length - 1];
			for(let index = keys.length - 1; index >= 0; index--){
				const neighbours = {}
				if(index > 0){
					neighbours.next = {
						index: keys[index - 1],
						entry: collection[keys[index - 1]]
					}
				}
				if(index < keys.length - 1){
					neighbours.prev = {
						index: keys[index + 1],
						entry: collection[keys[index + 1]]
					}
				}
				if(elementCallback(collection[keys[index]], keys[index], keys[index] === firstKey, keys[index] === lastKey, neighbours) === false) break;
			}
		}
	},

	/**
	 * this function is used like forEach but will traverse all elements within the given collection recursive
	 *
	 * @param   collection          array | object
	 * @param   elementCallback     function(value, key, collection, valueIsCollection)
	 * @param   checksDone          boolean - internal var only! are all necessary checks done
	 */
	forAll: function(collection, elementCallback, checksDone){
		if((checksDone || typeof(elementCallback) === 'function') && collection){
			var keys = Object.keys(collection);
			var result, index;
			var isCollection = false;
			for(index in keys){
				isCollection = utils.isCollection(collection[keys[index]]);
				result = elementCallback(collection[keys[index]], keys[index], collection, isCollection);
				if(result === 'break') return result;
				if(result !== 'breakRecursion' && isCollection){
					var childResult = utils.forAll(collection[keys[index]], elementCallback, true);
					if(childResult === 'break') return childResult;
				}
			}
		}
	},

	/**
	 * this function is used to perform a well known map operation on arrays as well as objects like lodash does
	 *
	 * @param   collection        array | object
	 * @param   elementCallback   function
	 * @returns collection containing referential replaced values within original collection
	 */
	map: function(collection, elementCallback){
		if(typeof(elementCallback) === 'function' && !this.isEmpty(collection)){
			var keys = Object.keys(collection);
			for(var index in keys){
				collection[keys[index]] = elementCallback(collection[keys[index]], keys[index]);
			}
		}

		return collection
	},

	/**
	 * this function behaves very similar to map() but does not change the original collection
	 *
	 * @param   collection        array | object
	 * @param   elementCallback   function
	 * @returns collection containing new values
	 */
	mapValue: function(collection, elementCallback){
		if(typeof(elementCallback) === 'function' && !this.isEmpty(collection)){
			var newCollection = {};
			if(utils.isArray(collection)) newCollection = [];
			var keys = Object.keys(collection);
			for(var index in keys){
				newCollection[keys[index]] = elementCallback(collection[keys[index]], keys[index]);
			}
		}

		return newCollection;
	},

	/**
	 * this function is used to perform a well known map operation on arrays as well as objects like lodash does.
	 *
	 * @param   collection          array | object
	 * @param   elementCallback     function
	 * @param   checksDone          boolean - internal var only! are all necessary checks done
	 * @returns void
	 */
	mapAll: function(collection, elementCallback, checksDone){
		if(checksDone || (typeof(elementCallback) === 'function' && !this.isEmpty(collection))){
			var keys = Object.keys(collection);
			var newValue;
			var i;
			var index;
			var deletionIndex = 0;
			var isArray = Array.isArray(collection);
			for(i in keys){
				if(isArray) index = keys[i] - deletionIndex;
				else 		index = keys[i];
				if(utils.isCollection(collection[index])) collection[index] = utils.mapAll(collection[index], elementCallback, true);
				if((newValue = elementCallback(collection[index], index)) === undefined){
					if(isArray){
						collection.splice(index, 1);
						deletionIndex++;
					}
					else{
						delete collection[index];
					}
				}
				else {
					collection[index] = newValue;
				}
			}
		}

		return collection;
	},

	/**
	 * this function is an extended version of the mapAll-method.
	 * the only difference is that the callback gets the parentCollection and parentKey as additional parameters.
	 *
	 * @param   collection          array | object
	 * @param   elementCallback     function
	 * @param   collectionKey       mixed - internal var only! key of actual given collection
	 * @param   checksDone          boolean - internal var only! are all necessary checks done
	 * @returns void
	 */
	mapAllWithParents: function(collection, elementCallback, collectionKey, checksDone){
		if(checksDone || (typeof(elementCallback) === 'function' && !this.isEmpty(collection))){
			var keys = Object.keys(collection);
			var newValue;
			var i;
			var index;
			var deletionIndex = 0;
			var isArray = Array.isArray(collection);
			// parents must not be changed via elementCallback!
			var parent;
			if(isArray){
				parent = [...collection]
			} else {
				parent = {...collection}
			}
			for(i in keys){
				if(isArray) index = keys[i] - deletionIndex;
				else 		index = keys[i];
				if(utils.isCollection(collection[index])) collection[index] = utils.mapAllWithParents(collection[index], elementCallback, index, true);
				if((newValue = elementCallback(collection[index], index, parent, collectionKey)) === undefined){
					if(isArray){
						collection.splice(index, 1);
						deletionIndex++;
					}
					else{
						delete collection[index];
					}
				}
				else {
					collection[index] = newValue;
				}
			}
		}

		return collection;
	},

	/**
	 * this function is used to concat all given parameter-arrays without changing any of them.
	 *
	 * @returns {Array}
	 */
	concat: function(){
		var result = [];
		var a, f;
		for(a in arguments){
			if(Array.isArray(arguments[a])){
				for(f in arguments[a]){
					result.push(arguments[a][f]);
				}
			}
		}
		// this.forEach(arguments, function(element){
		// 	if(Array.isArray(element)){
		// 		utils.forEach(element, function(fields) {
		// 			result.push(fields);
		// 		});
		// 	}
		// });
	    return result;
	},

	/**
	 * this function is used to merge multiple collections to one object where the right argument overwrites the left argument and the process order is from left to right.
	 * NOTE: this variant respects component-classes
	 * TODO: duplicate merge function solution needed!
	 * TODO: CLEANUP
	 *
	 * @returns {{}}
	 */
	merge: function(){
		try {
			stats.merges++;

			if(componentUndefined){
				componentUndefined = false;
				Component = require('./component');
			}

			var result = {};
			var start = 0;
			var a, f, fL, fK, field, fieldIndex;

			for(a = 0; a < arguments.length; a++){
				if(!utils.isEmpty(arguments[a])){
					if (arguments[a] === null)                  result = null;
					else if (Array.isArray(arguments[a]))       result = [];
					else if (arguments[a] instanceof Component) result = new Component(undefined, arguments[a].requestID, arguments[a].sessionID);
					else if (typeof arguments[a] === 'string') 	result = '' + arguments[a];
					else if (typeof arguments[a] !== 'object') 	result = arguments[a];
					break;
				}
			}

			var sourceIsArray,
				sourceIsNull,
				sourceIsSimple;

			for(a = start; a < arguments.length; a++){
				if(typeof arguments[a] === 'object' && arguments[a] != null){
					fK = Object.keys(arguments[a]);
					fL = fK.length;
					for(f = 0; f < fL; f++){
						fieldIndex = fK[f];
						field = arguments[a][fieldIndex];
						sourceIsArray = Array.isArray(field);
						sourceIsNull = field === null;
						sourceIsSimple = !sourceIsArray && (typeof(field) !== 'object' || sourceIsNull || (utils.$ && field instanceof utils.$) || field instanceof Component);

						// simple source value => set
						if(sourceIsSimple){
							result[fieldIndex] = field;
						}
						else {
							// empty target => init target according to source type
							if(utils.isEmpty(result[fieldIndex])) {
								if (sourceIsArray)          result[fieldIndex] = [];
								else if (sourceIsNull)      result[fieldIndex] = null;
								else                        result[fieldIndex] = {};
							}

							// source is filled collection
							if(!utils.isEmpty(field)){
								if(typeof(result[fieldIndex]) !== 'object' || result[fieldIndex] === null)  result[fieldIndex] = field;
								else                                                                        result[fieldIndex] = utils.merge(result[fieldIndex], field);
							}
						}
					}
				}
			}

			return result;
		} catch (error) {
			throw new Error(error.message)
		}
	},

	/**
	 * this function is used to merge multiple collections to one object where the right argument overwrites the left argument and the process order is from left to right.
	 *
	 * @returns {{}}
	 */
	simpleMerge: function(){
		try {
			stats.simpleMerges++;

			var result = {};
			var a;

			for(a = 0; a < arguments.length; a++){
				if(!utils.isEmpty(arguments[a])){
					if (arguments[a] === null)                  result = null;
					else if (Array.isArray(arguments[a]))       result = [];
					break;
				}
			}

			var f, fK, fL, fieldIndex, field;
			var sourceIsArray, sourceIsNull, sourceIsSimple;

			for(a = 0; a < arguments.length; a++){
				if(typeof arguments[a] === 'object' && arguments[a] != null){
					fK = Object.keys(arguments[a]);
					fL = fK.length;
					for(f = 0; f < fL; f++){

						fieldIndex = fK[f];
						field = arguments[a][fieldIndex];

						sourceIsArray = Array.isArray(field);
						sourceIsNull = field === null;
						sourceIsSimple = !sourceIsArray && (typeof(field) !== 'object' || sourceIsNull);

						// simple source value => set
						if(sourceIsSimple){
							result[fieldIndex] = field;
						}
						else {
							// empty target => init target according to source type
							if(utils.isEmpty(result[fieldIndex])) {
								if (sourceIsArray)          result[fieldIndex] = [];
								else if (sourceIsNull)      result[fieldIndex] = null;
								else                        result[fieldIndex] = {};
							}

							// source is filled collection
							if(!utils.isEmpty(field)){
								if(typeof(result[fieldIndex]) !== 'object' || result[fieldIndex] === null)  result[fieldIndex] = field;
								else                                                                        result[fieldIndex] = utils.simpleMerge(result[fieldIndex], field);
							}
						}
					}
				}
			}

			return result;
		} catch (error) {
			throw new Error(error.message)
		}
	},

	/**
	 * this function works pretty much like utils.merge but uses the first argument as reference.
	 */
	refMerge: function(){
		try {
			stats.refMerges++;

			if(arguments.length < 2) return;

			var a;
			var result = arguments[0];
			var f, fK, fL, fieldIndex, field;

			for(a = 1; a < arguments.length; a++){
				if(typeof arguments[a] === 'object' && arguments[a] != null){
					fK = Object.keys(arguments[a]);
					fL = fK.length;
					for(f = 0; f < fL; f++){

						fieldIndex = fK[f];
						field = arguments[a][fieldIndex];

						var sourceIsArray = Array.isArray(field);
						var sourceIsNull = field === null;
						var sourceIsSimple = !sourceIsArray && (typeof(field) !== 'object' || sourceIsNull);

						// simple source value => set
						if(sourceIsSimple){
							result[fieldIndex] = field;
						}
						else {
							// empty target => init target according to source type
							if(utils.isEmpty(result[fieldIndex])) {
								if (sourceIsArray)          result[fieldIndex] = [];
								else if (sourceIsNull)      result[fieldIndex] = null;
								else                        result[fieldIndex] = {};
							}

							// source is filled collection
							if(!utils.isEmpty(field)){
								if(typeof(result[fieldIndex]) !== 'object' || result[fieldIndex] === null)  result[fieldIndex] = field;
								else                                                                        utils.refMerge(result[fieldIndex], field);
							}
						}
					}
				}
			}
		} catch (error) {
			throw new Error(error.message)
		}
	},

	/**
	 * this function is used to replace all items of multiple collections to one object where the right argument overwrites the left argument and the process order is from left to right.
	 *
	 * @returns {{}}
	 */
	replace: function(){
		stats.replaces++;

		if(componentUndefined){
			componentUndefined = false;
			Component = require('./component');
		}

		var result = {};
		var a;
		for(a = 0; a < arguments.length; a++){
			if(!utils.isEmpty(arguments[a])){
				// TODO: not isEmpty but null?!?!
				if (arguments[a] === null)                  result = null;
				else if (Array.isArray(arguments[a]))       result = [];
				else if (arguments[a] instanceof Component) result = new Component(undefined, arguments[a].requestID, arguments[a].sessionID);
				break;
			}
		}

		this.forEach(arguments, function(collection){
			utils.forEach(collection, function(field, fieldIndex){
				if(field === undefined) delete result[fieldIndex];
				else 					result[fieldIndex] = field;
			});
		});

		return result;
	},

	/**
	 * this function works just like replace except undefined attributes will not be deleted but set undefined instead.
	 *
	 * @returns {{}}
	 */
	fullReplace: function(){
		stats.replaces++;

        if(componentUndefined){
            componentUndefined = false;
            Component = require('./component');
        }

		var result = {};
		var a;
		for(a = 0; a < arguments.length; a++){
			if(!utils.isEmpty(arguments[a])){
				if (arguments[a] === null)                  result = null;
				else if (Array.isArray(arguments[a]))       result = [];
				else if (arguments[a] instanceof Component) result = new Component(undefined, arguments[a].requestID, arguments[a].sessionID);
				break;
			}
		}

		// TODO: normal loops?
		this.forEach(arguments, function(collection){
			utils.forEach(collection, function(field, fieldIndex){
				result[fieldIndex] = field;
			});
		});

		return result;
	},

	/**
	 * this function works pretty much like utils.replace but uses the first argument as reference.
	 */
	refReplace: function(){
		if(arguments.length < 2) return;

		var a;
		var result = arguments[0];

		for(a = 1; a < arguments.length; a++) {
			utils.forEach(arguments[a], function (field, fieldIndex) {
				if(field === undefined) delete result[fieldIndex];
				else 					result[fieldIndex] = field;
			});
		}
	},

	/**
	 * this function is used to remove all items identified by multiple collections' elements' keys within the first collection given.
	 *
	 * @param element, ...
	 * @returns firstArgument mixed (can be a collection of elements without the keys of the given arguments
	 */
	remove: function(){
		if(this.isCollection(arguments[0])){
			let result
			if(this.isArray(arguments[0])){
				result = [...arguments[0]];
			} else {
				result = {...arguments[0]};
			}

			if(arguments.length > 1){
				for(let a = 1; a < arguments.length; a++){
					for(let fieldIndex in arguments[a]){
						delete result[fieldIndex];
					}
				}
			}

			return result
		}

		return arguments[0]
	},

	/**
	 * this method is used for simply get a copy of an element.
	 *
	 * @param element
	 * @returns mixed
	 */
	copy: function(){
		return this.merge(arguments[0]);
	},

	/**
	 * supports primitives objects and arrays only but is tremendously faster than a copy or merge.
	 * @param value
	 * @returns {{}|Array|*}
	 */
	simpleCopy: function(value) {
		try {
			// return simple value
			if (typeof value !== 'object' || value === null) {
				return value;
			}

			// return references for all known complex objects
			// TODO: what about the other simple...() functions?
			if(componentUndefined){
				componentUndefined = false;
				Component = require('./component');
			}
			if(
				(utils.$ && value instanceof utils.$)
				||
				(value instanceof Component)
			){
				return value
			}


			var newValue, i;
			// copy array
			if (value instanceof Array) {
				var l;
				newValue = [];
				for (i = 0, l = value.length; i < l; i++) {
					newValue[i] = utils.simpleCopy(value[i]);
				}
				return newValue;
			}

			// copy object
			newValue = {};
			for (i in value) {
				if (value.hasOwnProperty(i)) {
					newValue[i] = utils.simpleCopy(value[i]);
				}
			}
			return newValue;
		} catch (error) {
			throw new Error(error.message)
		}
	},

	/**
	 * works just like simpleCopy but uses the given reference as a target.
	 * NOTE: 	simpleCopy supports primitive types on the first level.
	 * 			refSimpleCopy has to have objects within the first level
	 * 			of target and value for the referential addressing to work.
	 *
	 * @param target		object - referential target
	 * @param value			object - value to be copied to target.
	 * @returns void
	 */
	refSimpleCopy: function(target, value) {
		if(
			typeof target === 'object' && target !== null && !(target instanceof Array)
			&&
			typeof value === 'object' && value !== null && !(value instanceof Array)
		){
			refSimpleCopy({ target: target }, value, 'target');
		} else {
			throw new Error('refSimpleCopy() - MISSING OBJECT');
		}
	},

	/**
	 * this function is used to get a value which is reachable by a cascade of keys within a collection.
	 *
	 * @param   collection  		{} | [] - array or object which should contain the key cascade
	 * @param   keys        		[] | string - list of keys within the wanted cascade or string containing dot-separated fields.
	 * 									e.g., ['data', '0', 'attributes']
	 * 									e.g., data[0].attributes
	 * 									e.g., data.0.attributes
	 * 									e.g., data?.0?.attributes
	 * @param   recursiveCall		boolean - is this a recursive call
	 * 								NOTE: for internal usage only!
	 * @returns {*} - collection value according to the given keys or undefined if the wanted value does not exist.
	 */
	getCollectionValue: function(collection, keys, recursiveCall){
		if(utils.isEmpty(collection) || utils.isEmpty(keys)) return undefined;
		if(!utils.isArray(keys)){
			if(typeof keys === 'string') 	keys = keys.split(/[.\[\]?]+/).filter(value => !!value);
			else 							return undefined;
		}
		if(!recursiveCall) keys = utils.collectionValues(keys);
		var key = keys.shift();

		if(key !== 0 && utils.isEmpty(key))             return undefined;
		if(typeof(collection[key]) === 'undefined')     return undefined;
		if(keys.length <= 0)                            return collection[key];
		if(!utils.isCollection(collection[key]))        return undefined;

		return utils.getCollectionValue(collection[key], keys, true);
	},

	/**
	 * this function is used to set a value which is reachable by a cascade of keys within a collection.
	 *
	 * @param   collection  		{} | [] - array or object which should contain the key cascade
	 * @param   keys        		array - list of keys within the wanted cascade.
	 * @param   value       		mixed - this is the value which should replace the existing value behind the key cascade within the collection.
	 * @param   recursiveCall		boolean - is this a recursive call
	 * 								NOTE: for internal usage only!
	 * @returns true - in success case or throws an error object
	 */
	setCollectionValue: function(collection, keys, value, recursiveCall){
		if(!utils.isCollection(collection) || utils.isEmpty(keys) || !utils.isArray(keys)) throw new Error('utils.setCollectionValue() - invalid call!');
		if(!recursiveCall) keys = utils.collectionValues(keys);

		var key = keys.shift();

		if(key !== 0 && utils.isEmpty(key)) throw new Error('utils.setCollectionValue() - invalid key!');
		if(keys.length <= 0){
			collection[key] = value;
			return true;
		}

		if(typeof(collection[key]) === 'undefined'){
			collection[key] = {};
		}

		utils.setCollectionValue(collection[key], keys, value, true);
		return true;
	},

	// TODO: split promise stuff into server- and client-utils
	promise: {
		/**
		 * this is a wrapper function for jquery-promise resolve
		 *
		 * @param   resolveData     object - this is the optional data flag which should be resolved. default: {}
		 * @returns {*|{resolve}}
		 */
		resolve: function(resolveData = {}){
			var deferred = (utils.$ || globalThis.$).Deferred(); // TODO: POIA: check this fucker
			deferred.resolve(resolveData || {});
			return deferred.promise();
		},

		/**
		 * this is a wrapper function for jquery-promise resolve
		 *
		 * @param   rejectData     object - this is the optional data flag which should be resolved. default: {}
		 * @returns {*|{resolve}}
		 */
		reject: function(rejectData){
			// return promise
			var fallback = (utils.$ || globalThis.$).Deferred();
			fallback.reject(rejectData || {});
			return fallback.promise();
		},

		/**
		 * this function is used to abort a promise chain without breaking the used promise-callback-functions usage afterwards.
		 * TODO: check which functions should also be overwritten.
		 *
		 * @return Pseudo-Promise doing nothing except for always
		 */
		abort: function(abortionData){

			var fallback = (utils.$ || globalThis.$).Deferred();
			fallback.reject(abortionData || {});
			var promise = fallback.promise();

			promise.then = function(){};
			promise.fail = function(){};
			promise.done = function(){};

			return promise;
		},

		/**
		 * this function is used to perform an independent list of promises given in chain-parameter one after another.
		 * NOTE: in difference to performAll this function does NOT perform the given promises in parallel.
		 *
		 * @param   chain       array - list of functions which return a promise
		 * @param   responses   array - list of functions which return a promise
		 * 						NOTE: INTERNAL ONLY!!!
		 * @returns Promise
		 */
		performChain: function(chain, responses){
			responses = responses || []
			if(chain === undefined) chain = [];
			if(chain.length > 0){
				var element = chain.shift();
				if(utils.isFunction(element)) {
					return element().then(function(response){
						responses.push(response)
						return utils.promise.performChain(chain, responses);
					});
				}
				else {
					// TODO: throw error
					console.error('perform chain has found an element which is not a function');
				}
			}

			return utils.promise.resolve(responses);
		},

		/**
		 * this function is used to perform an independent list of promises given in chain-parameter.
		 * NOTE: this function performs all promises within chain-parameter in parallel.
		 * NOTE: this function is based on jquerys $.when
		 *
		 * @param   context     object - context object which should perform $.when
		 * @param   chain       array - list of promises
		 * @returns Promise
		 */
		performAll: function(context, chain){
			if(chain === undefined) chain = [];
			if(context !== undefined && chain.length > 0) {
				return utils.$.when.apply(context, chain);
			}
			return utils.promise.resolve();
		},

		/**
		 * this function is used to perform an action chain of lists of parallel executable actions.
		 *
		 * @param   context         Component - context of promise execution
		 * @param   chain           action chain
		 *                          {
		 *                              <key>: [ <Promise> || function(){ return <Promise>; }, ... ],
	     *                              ...
	     *                          }
		 * @param   bulkIndex       int - actual bulkIndex
		 *                          NOTE: this index is used for internal function calls and must not be set by external ones!!
		 * @returns Promise
		 */
		performAllChains: function(context, chain, bulkIndex){
			bulkIndex = bulkIndex || 0;
			var bulkKeys = Object.keys(chain);
			var bulkKey = bulkKeys[bulkIndex];

			if(!utils.isEmpty(chain[bulkKey])){
				utils.map(chain[bulkKey], function(element){ return (utils.isFunction(element) ? element() : element); });
				return utils.promise.performAll(context, chain[bulkKey]).then(function(resolveData){
					chain[bulkKey] = resolveData;
					return utils.promise.performAllChains(context, chain, bulkIndex + 1);
				});
			}

			// ignore emptyChain?
			if(bulkIndex < (bulkKeys.length - 1)){
				return utils.promise.performAllChains(context, chain, bulkIndex + 1);
			}

			return utils.promise.resolve(chain);
		},

		/**
		 * this function is used to perform an independent list of promises given in chain-parameter.
		 * NOTE: this function performs all promises within chain-parameter in parallel.
		 * NOTE: this function behaves slightly different to $.when in some ways:
		 * 		 1) all promises have to resolve or reject until the returned promise is resolved. ($.when rejects when the first rejection occurs)
		 * 		 2) the returned promise will resolve if one chain element has been rejected or not. rejections have to be handled according to the resolved status object afterward.
		 *
		 * @param   context     object - context object which should perform $.when
		 * @param   chain       array - list of promises
		 * @returns Promise		resolves object of format:
		 * 		{
		 * 			nrOfResolves: 0,
		 * 			nrOfRejections: 0,
		 * 			nrOfPromises: 0,
		 * 			isRejected: false,
		 * 			results: [<resolved or rejected value of the corresponding chain promise>] result list order corresponds to the order of the given chain.
		 * 		}
		 */
		resolveAll: function(context, chain){
			const overallDeferred = (utils.$ || globalThis.$).Deferred();
			const overallPromise = overallDeferred.promise();
			const status = {
				nrOfResolves: 0,
				nrOfRejections: 0,
				nrOfPromises: 0,
				isRejected: false,
				results: []
			}

			if(chain === undefined) chain = [];
			if(context !== undefined && chain.length > 0) {
				status.nrOfPromises = chain.length
				let catcher, finalizer

				for(const pI in chain){
					let promise = chain[pI]
					if(utils.isFunction(promise)){
						promise = promise()
					}

					// jquery deferred vs native promise
					catcher = 'catch'
					finalizer = 'finally'
					if(utils.isFunction(promise.fail) && utils.isFunction(promise.always)){
						catcher = 'fail'
						finalizer = 'always'
					}

					promise
						.then(r => {
							status.nrOfResolves++
							status.results[pI] = r
						})
						[catcher](e => {
							status.nrOfRejections++
							status.isRejected = true
							status.results[pI] = e
						})
						[finalizer](() => {
							if(status.nrOfResolves + status.nrOfRejections >= status.nrOfPromises){
								overallDeferred.resolve.apply(context, [status])
							}
						})
				}
			} else {
				overallDeferred.resolve.apply(context, [status])
			}

			return overallPromise;
		},


		/**
		 * this function is used to perform an independent list of promises given in chain-parameter.
		 * NOTE: this function performs all promises within chain-parameter in series if they are functions and in parallel if they are promises already.
		 * NOTE: this function behaves slightly different to utils.promise.resolveAll():
		 * 		 1) it recognizes that the chain parameter may have been extended between the original call and the return of one subsequent promise.
		 * 		 	ATTENTION: if someone shrinks the list within chain parameter during execution this function would not work as expected!
		 *
		 * @param   context    			object - context object which should perform $.when
		 * @param   chain       		array - list of promises
		 * @param   overallDeferred     jquery.Deferred - FOR INTERNAL USE ONLY!!!
		 * @param   overallPromise      Promise - FOR INTERNAL USE ONLY!!!
		 * @param   status              object - FOR INTERNAL USE ONLY!!!
		 * @returns Promise				resolves object of format:
		 * 		{
		 * 			nrOfResolves: 0,
		 * 			nrOfRejections: 0,
		 * 			nrOfPromises: 0,
		 * 			isRejected: false,
		 * 			results: [<resolved or rejected value of the corresponding chain promise>] result list order corresponds to the order of the given chain.
		 * 		}
		 */
		resolveAllDynamicList: function(context, chain, overallDeferred, overallPromise, status){
			overallDeferred = overallDeferred || (utils.$ || globalThis.$).Deferred();
			overallPromise = overallPromise || overallDeferred.promise();
			status = status || {
				keys: [],
				index: -1,

				nrOfResolves: 0,
				nrOfRejections: 0,
				nrOfPromises: 0,
				isRejected: false,
				results: []
			}

			if(chain === undefined) chain = [];
			if(context !== undefined && chain.length > 0) {
				status.keys = Object.keys(chain)
				status.nrOfPromises = chain.length
				status.index++
				const key = status.keys[status.index]

				let promise = chain[key]
				if(utils.isFunction(promise)){
					promise = promise()
				}

				promise
					.then(r => {
						status.nrOfResolves++
						status.results[key] = r
					})
					.fail(e => {
						status.nrOfRejections++
						status.isRejected = true
						status.results[key] = e
					})
					.always(() => {
						if(status.nrOfPromises !== chain.length){
							status.nrOfPromises = chain.length
						}
						if(status.nrOfResolves + status.nrOfRejections >= status.nrOfPromises){
							delete status.keys
							delete status.index
							overallDeferred.resolve.apply(context, [status])
						} else {
							return utils.promise.resolveAllDynamicList(context, chain, overallDeferred, overallPromise, status)
						}
					})
			} else {
				delete status.keys
				delete status.index
				overallDeferred.resolve.apply(context, [status])
			}

			return overallPromise;
		},

		/**
		 * this function is used to perform one promise after another returned by the functions given in the chain-parameter.
		 * if and when the first promise is rejected the chain will be aborted.
		 * the results including the error can be found within the resolved status.
		 * this function resolves regardless of the chain elements promise status.
		 *
		 * @param   context     		object - context object which should perform $.when
		 * @param   chain       		array - list of functions returning promises
		 * @param   overallDeferred     jquery.Deferred - FOR INTERNAL USE ONLY!!!
		 * @param   overallPromise      Promise - FOR INTERNAL USE ONLY!!!
		 * @param   status            	object - FOR INTERNAL USE ONLY!!!
		 * @returns Promise		resolves object of format:
		 * 		{
		 * 			nrOfResolves: 0,
		 * 			nrOfRejections: 0,
		 * 			nrOfPromises: 0,
		 * 			isRejected: false,
		 * 			rejection: null, this may be set by the rejection result responsible for aborting the chain.
		 * 			results: [<resolved or rejected value of the corresponding chain promise>] result list order corresponds to the order of the given chain.
		 * 		}
		 */
		resolveChain: function(context, chain, overallDeferred, overallPromise, status){
			overallDeferred = overallDeferred || (utils.$ || globalThis.$).Deferred();
			overallPromise = overallPromise || overallDeferred.promise();
			status = status || {
				elementIndex: -1,
				nrOfResolves: 0,
				nrOfRejections: 0,
				nrOfPromises: 0,
				isRejected: false,
				rejection: null,
				results: []
			}

			if(chain === undefined) chain = [];
			if(context !== undefined && chain.length > 0) {
				status.nrOfPromises = status.nrOfPromises || chain.length

				let element = chain.shift();
				if(!utils.isFunction(element)) {
					element = () => utils.promise.reject(new Error('utils.promise.resolveChain() has found an element which is not a function'))
				}

				status.elementIndex++
				const promise = element()
				let catcher = 'catch', finalizer = 'finally'
				if(utils.isFunction(promise.fail) && utils.isFunction(promise.always)){
					catcher = 'fail'
					finalizer = 'always'
				}

				promise
					.then(r => {
						status.nrOfResolves++
						status.results[status.elementIndex] = r
					})
					[catcher](e => {
						status.nrOfRejections++
						status.isRejected = true
						status.results[status.elementIndex] = e
						status.rejection = e
					})
					[finalizer](() => {
						if(
							// end of chain reached
							(status.nrOfResolves + status.nrOfRejections >= status.nrOfPromises)
							||
							// prevent rest of the chain from being invoked
							status.isRejected
						){
							delete status.elementIndex
							overallDeferred.resolve.apply(context, [status])
						} else {
							return utils.promise.resolveChain(context, chain, overallDeferred, overallPromise, status);
						}
					})

			} else {
				delete status.elementIndex
				overallDeferred.resolve.apply(context, [status])
			}

			return overallPromise;
		},

		/**
		 * this function resolves or rejects (according to the resolve param) after given delay.
		 * this may come in handy for debugging or other time sensitive stuff.
		 *
		 * @param delay			number - default: 100 - ms to wait
		 * @param resolve		boolean - default: true - resolve or not
		 * @returns {jQuery.Promise}
		 */
		delayed: function(delay = 100, resolve = true){
			const overallDeferred = (utils.$ || globalThis.$).Deferred();
			const overallPromise = overallDeferred.promise();

			setTimeout(deferred => {
				if(resolve){
					deferred.resolve()
				} else {
					deferred.reject()
				}
			}, delay, overallDeferred)

			return overallPromise
		},

		/**
		 * returns a new custom promise extended by a resolve() function which may be called from anyone.
		 * the context of this very resolve() call is given via context-param.
		 *
		 * @param context				object - resolve context
		 * @param [rejectAfterTimeout]	number - number of milliseconds to wait until a CUSTOM_PROMISE_TIMEOUT_REACHED error will reject the given promise.
		 * @returns {jQuery.Promise}
		 */
		newCustom: function(context, rejectAfterTimeout = 0){
			const deferred = (utils.$ || globalThis.$).Deferred();
			const promise = deferred.promise();
			promise.isResolved = false
			promise.isRejected = false
			promise.isDone = false
			promise.resolve = function(){
				promise.isResolved = promise.isDone = true
				if(promise.timeout){
					clearTimeout(promise.timeout)
					delete promise.timeout
				}
				deferred.resolve.apply(context, arguments)
			}
			promise.reject = function(){
				promise.isRejected = promise.isDone = true
				if(promise.timeout){
					clearTimeout(promise.timeout)
					delete promise.timeout
				}
				deferred.reject.apply(context, arguments)
			}
			if(rejectAfterTimeout){
				promise.timeout = setTimeout(() => {
					promise.reject(new Error('CUSTOM_PROMISE_TIMEOUT_REACHED'))
				}, rejectAfterTimeout)
			}

			return promise;
		}
	},

	media: {
		/**
		 * this function will be called when a public media is requested from the app
		 *
		 * @param res       object - express response object
		 */
		setHeaders: function(res){
			res.setHeader('Expires', '365d');
			res.setHeader('Pragma', 'public');
			res.setHeader('Cache-Control', 'public');
		},

		/**
		 * this function is used to get the mediaData according to index driven dataJSON of a media-image.
		 *
		 * @param   dataJSON        object - dataJSON field of media-image
		 * @param   mediaID         int - wanted mediaID
		 * @return  undefined | {} - mediaData
		 */
		getMediaDataByID: function(dataJSON, mediaID){
			for(const entity of Object.values(dataJSON || {})){
				if(entity.mediaID == mediaID){
					return entity
				}
			}
		},

		/**
		 * this function is used to return the given image-title for in-url-usage.
		 *
		 * @param   title       string - original image title
		 * @return  string - url ready image title
		 */
		getUrlReadyTitle: function(title){
			return String(removeDiacritics(String(title || '')))
				.toLowerCase()
				.replace(/[^a-z0-9-]+/gi, '-')
				.replace(/[-]+/g, '-')
				.replace(/^-+/, '')
				.replace(/-+$/, '')
			;
		},

		/**
		 * restricted media may have to add the actual scope so a user may have access to it.
		 * TODO: POIA
		 *
		 * @param url			string
		 * @param scope			string
		 * @returns url 		string
		 */
		getScopedUrl: function(url, scope){
			return String(url || '').replace(/^((http)?s?:?\/\/[^\/]+)?\/~media\/(\d+~\d+(~\d+)?)\//, `$1/~media/${scope || '~'}/$3/`)
		},

		file: {

			/**
			 * prepare media according to the given resource data flag.
			 * NOTE: this function manipulates the media param by reference!
			 *
			 * @param media					object - mediaData according to resourceTemplates like getCategorizedFiles, getCategorizedFilesFull
			 * 								e.g., { attributes: { mediaID: 13, ... }, children: { ... }}
			 * @param storage				object - actual storage
			 * @param requestedServiceCode	string | boolean - false => ownService, true => webService, string => requestedServiceCode within assignedServices.
			 * @param scope             	string - which scope should be used to determine if the actual user has mimicOwner privileges?
			 */
			prepare: function(media, storage, requestedServiceCode, scope){
				// init
				if(media === undefined) 		media = {};
				requestedServiceCode = utils.sanitizeRequestedServiceCode(storage, requestedServiceCode)

				// identify service to use
				const usedService = utils.getRequestedService(storage, requestedServiceCode)
				if(!usedService){
					console.error('media could not find the service to use')
					return false
				}

				const langCode = storage.langCode || ((appConfig || {}).language || {}).default || 'de-at'

				// define image name without extension if necessary
				var mediaAttributes = media.attributes || {};
				if(mediaAttributes.originalName) {
					var nameParts = String(mediaAttributes.originalName).split('.');
					if(nameParts.length > 1){
						// remove extension
						nameParts.pop();
					}
					// get image name without any dots (dots are not allowed to prevent nginx redirect errors)
					mediaAttributes.name = nameParts.join('.');
				} else {
					console.error('originalName not found in file');
				}

				// prepare media data flags
				var mediaLangAttributes = {};

				// prepare original media's lang data
				if((mediaAttributes.cms_mediaTrl || {})[langCode]){
					mediaLangAttributes = mediaAttributes.cms_mediaTrl[langCode];

					// override lang dependent fields
					if(mediaLangAttributes.name) 		mediaAttributes.name = mediaLangAttributes.name;
					if(mediaLangAttributes.title) 		mediaAttributes.title = mediaLangAttributes.title;
					if(mediaLangAttributes.alt) 		mediaAttributes.alt = mediaLangAttributes.alt;
					if(mediaLangAttributes.info) 		mediaAttributes.info = mediaLangAttributes.info;
					if(mediaLangAttributes.description) mediaAttributes.description = mediaLangAttributes.description;
				}

				utils.media.file.prepareUrls(mediaAttributes, usedService, requestedServiceCode, scope)

				// prepare tags
				mediaAttributes.tagsResources = ((media || {}).children || {}).cms_entities_categories || {};
				mediaAttributes.tags = {};
				var ec, categoryDataAttributes, tagName;
				var cmsEntitiesCategories = mediaAttributes.tagsResources.data || [];
				for(ec in cmsEntitiesCategories){
					if((categoryDataAttributes = ((((cmsEntitiesCategories[ec] || {}).children || {}).cms_categoriesData || {}).data || {}).attributes)){
						tagName = categoryDataAttributes.value || '';
						if(((categoryDataAttributes.trls || {})[langCode] || {}).name){
							tagName = categoryDataAttributes.trls[langCode].name;
						}

						mediaAttributes.tags[utils.collectionSize(mediaAttributes.tags)] = utils.replace(categoryDataAttributes, {
							trls: undefined,
							name: tagName
						});
					}
				}

				// prepare highlighting for new media if necessary
				if ((((storage || {}).app || {}).service || {}).applicationType === 'cms'){
					mediaAttributes.isNew = mediaAttributes.createdAt && (new Date().getTime() - new Date(mediaAttributes.createdAt).getTime() < 7200000)
				}

				// simplify data
				utils.refReplace(media, mediaAttributes);

				// cleanup
				delete media.attributes;
				delete media.children;
				delete media.primaryKey;
			},

			/**
			 * this function is used to prepare the urls of one single set of mediaAttributes by reference.
			 *
			 * @param mediaAttributes		object - media's attributes
			 * @param service               object - service which should be used for preparation.
			 * @param requestedServiceCode  string | boolean - false => ownService, true => webService, string => requestedServiceCode within assignedServices.
			 * @param scope                 string - which scope should be used to determine if the actual user has mimicOwner privileges?
			 */
			prepareUrls: function(mediaAttributes, service, requestedServiceCode, scope){
				mediaAttributes = mediaAttributes || {}

				let basePath, filename
				const target = mediaAttributes
				const mediaID = mediaAttributes.mediaID || 0
				const mediaGroup = mediaID % 50
				const mediaUrl = (service || {}).mediaUrl
				const serviceUrl = (service || {}).url

				if(mediaAttributes.urlName) {
					filename = mediaAttributes.urlName;
				}
				else {
					if(mediaAttributes.name)	filename = mediaAttributes.name;
					else  						filename = 'file';
					mediaAttributes.urlName = filename = utils.media.getUrlReadyTitle(filename)
				}

				let url = mediaUrl || serviceUrl
				if(((mediaAttributes.permissions || {}).public || {}).read === false){
					url = ''
					basePath = `/~media/${requestedServiceCode || '~'}/${scope || '~'}/${mediaGroup}~${mediaID}/`
				} else {
					basePath = `/~media/${mediaGroup}~${mediaID}/`
				}

				const path = basePath + filename + '.' + mediaAttributes.extension
				const thumbPath = basePath + filename + '.symbol.' + mediaAttributes.extension

				target.url 		= (url || '') + path
				target.thumb 	= (url || '') + thumbPath
			},

			/**
			 * remove unnecessary flags from assignmentMedia right before it will be written to the database
			 *
			 * @param media
			 * @returns mediaData needed for assignment (e.g., dataJSON of templateAtom)
			 */
			cleanupElementBeforeSet: function(media){
				media = media || {};
				return {
					mediaID: 	media.mediaID,
					data: 		media.data
				}
			},

			/**
			 * this function returns the symbol css-class used for the given extension
			 *
			 * @param 	extension		string - file extension
			 * @return 	string - symbol class
			 */
			getSymbolClass: function(extension){
				switch((extension || '').toLowerCase()){
					case 'gif':
					case 'jpg':
					case 'jpeg':
					case 'tiff':
					case 'png':
					case 'svg': return 'fi fi-file-image-o';
					case 'xls':
					case 'xlsx':
					case 'csv': return 'fi fi-file-excel-o';
					case 'txt': return 'fi fi-file-text-o';
					case 'pdf': return 'fi fi-file-pdf-o';
					default: return 'fi fi-file-o';
				}
			}
		},

		image: {

			/**
			 * prepare media according to the given resource data flag.
			 * NOTE: this function manipulates the media param by reference!
			 *
			 * @param media					object - mediaData according to resourceTemplates like getCategorizedMedia, getCategorizedMediaFull
			 * 								e.g., { attributes: { mediaID: 13, ... }, children: { ... }}
			 * @param storage				object - actual storage
			 * @param requestedServiceCode  string | boolean - false => ownService, true => webService, string => requestedServiceCode within assignedServices.
			 * @param scope					string - which scope should be used to determine if the actual user has mimicOwner privileges?
			 */
			prepare: function(media, storage, requestedServiceCode, scope){
				// init
				if(media === undefined) media = {};
				requestedServiceCode = utils.sanitizeRequestedServiceCode(storage, requestedServiceCode)

				// identify service to use
				const service = ((storage || {}).app || {}).service || {}
				const usedService = utils.getRequestedService(storage, requestedServiceCode)
				if(!usedService){
					console.error('media could not find the service to use')
					return false
				}

				const langCode = storage.langCode || ((appConfig || {}).language || {}).default || 'de-at'

				// define image name without extension if necessary
				const mediaAttributes = media.attributes || {}
				if(mediaAttributes.originalName) {
					var nameParts = String(mediaAttributes.originalName).split('.');
					if(nameParts.length > 1){
						// remove extension
						nameParts.pop();
					}
					// get image name without any dots (dots are not allowed to prevent nginx redirect errors)
					mediaAttributes.name = nameParts.join('.');
				} else {
					console.error('originalName not found in image');
				}

				// prepare media data flags
				var mediaLangAttributes = {};
				var assignedMediaData = {};
				var assignedMediaAttributes = {};
				var assignedMediaLangAttributes = {};
				var assignedMediaLangDataIndex;

				// prepare original media's lang data
				if((mediaAttributes.cms_mediaTrl || {})[langCode]){
					mediaLangAttributes = mediaAttributes.cms_mediaTrl[langCode];

					// override lang dependent fields
					if(mediaLangAttributes.name) 		mediaAttributes.name = mediaLangAttributes.name;
					if(mediaLangAttributes.title) 		mediaAttributes.title = mediaLangAttributes.title;
					if(mediaLangAttributes.alt) 		mediaAttributes.alt = mediaLangAttributes.alt;
					if(mediaLangAttributes.info) 		mediaAttributes.info = mediaLangAttributes.info;
					if(mediaLangAttributes.description) mediaAttributes.description = mediaLangAttributes.description;
				}

				// prepare assignment media data
				if(((media.children || {}).cms_assignedMedia || {}).data){
					assignedMediaData = media.children.cms_assignedMedia.data;
					assignedMediaAttributes = assignedMediaData.attributes || {};

					// override lang independent assignment fields
					if(assignedMediaAttributes.name) 		mediaAttributes.name = assignedMediaAttributes.name;

					// prepare assignment media lang dependent data
					for(assignedMediaLangDataIndex in ((assignedMediaData.relationships || {}).lang || {}).data || []){
						if((assignedMediaData.relationships.lang.data[assignedMediaLangDataIndex].attributes || {}).lang === langCode){
							assignedMediaLangAttributes = assignedMediaData.relationships.lang.data[assignedMediaLangDataIndex].attributes;

							// override lang dependent assignment fields
							if(assignedMediaLangAttributes.title) 	mediaAttributes.title = assignedMediaLangAttributes.title;
							if(assignedMediaLangAttributes.alt) 	mediaAttributes.alt = assignedMediaLangAttributes.alt;
						}
					}
				}

				utils.media.image.prepareUrls(mediaAttributes, undefined, usedService, requestedServiceCode, scope);

				// prepare tags
				mediaAttributes.tagsResources = ((media || {}).children || {}).cms_entities_categories || {};
				mediaAttributes.tags = {};
				var ec, categoryDataAttributes, tagName;
				var cmsEntitiesCategories = mediaAttributes.tagsResources.data || [];
				for(ec in cmsEntitiesCategories){
					if((categoryDataAttributes = ((((cmsEntitiesCategories[ec] || {}).children || {}).cms_categoriesData || {}).data || {}).attributes)){
						tagName = categoryDataAttributes.value || '';
						if(((categoryDataAttributes.trls || {})[langCode] || {}).name){
							tagName = categoryDataAttributes.trls[langCode].name;
						}

						mediaAttributes.tags[utils.collectionSize(mediaAttributes.tags)] = utils.replace(categoryDataAttributes, {
							trls: undefined,
							name: tagName
						});
					}
				}

				// prepare rendered
				var mr, mediaRendered = (((media || {}).children || {}).cms_mediaRendered || {}).data || [];
				mediaAttributes.rendered = [];
				for(mr in mediaRendered){
					if((mediaRendered[mr] || {}).attributes){
						utils.media.image.prepareUrls(mediaAttributes, mediaRendered[mr].attributes, usedService, requestedServiceCode, scope)
						mediaAttributes.rendered.push(mediaRendered[mr].attributes);
					}
				}

				// prepare highlighting for new media if necessary
				if (service.applicationType === 'cms'){
					mediaAttributes.isNew = mediaAttributes.createdAt && (new Date().getTime() - new Date(mediaAttributes.createdAt).getTime() < 7200000)
				}

				// simplify data
				utils.refReplace(media, mediaAttributes);

				// downwards compatibility stuff
				media.data = ((media.children || {}).cms_assignedMedia || {}).data || {};

				// cleanup
				delete media.attributes;
				delete media.children;
				delete media.primaryKey;
			},

			/**
			 * this function is used to prepare the urls of one single set of mediaAttributes (or renderedMediaAttributes) by reference.
			 *
			 * @param mediaAttributes			object - media's attributes
			 * @param renderedMediaAttributes	object - rendered media's attributes (may be undefined)
			 * @param service					object - service which should be used for preparation.
			 * @param requestedServiceCode  	string | boolean - false => ownService, true => webService, string => requestedServiceCode within assignedServices.
			 * @param scope                		string - which scope should be used to determine if the actual user has mimicOwner privileges?
			 */
			prepareUrls: function(mediaAttributes, renderedMediaAttributes, service, requestedServiceCode, scope){
				mediaAttributes = mediaAttributes || {}

				let target, mediaRenderedID, basePath, filename
				const mediaID = mediaAttributes.mediaID || 0;
				const mediaGroup = mediaID % 50;
				const mediaUrl = (service || {}).mediaUrl
				const serviceUrl = (service || {}).url

				if(renderedMediaAttributes){
					target = renderedMediaAttributes;
					mediaRenderedID = renderedMediaAttributes.mediaRenderedID;
				} else {
					target = mediaAttributes;
				}

				if(mediaAttributes.urlName) {
					filename = mediaAttributes.urlName;
				}
				else {
					if(mediaAttributes.name) 	filename = mediaAttributes.name;
					else  						filename = 'image';
					mediaAttributes.urlName = filename = utils.media.getUrlReadyTitle(filename)
				}

				let url = mediaUrl || serviceUrl
				if(((mediaAttributes.permissions || {}).public || {}).read === false){
					url = ''
					if(mediaRenderedID) basePath = `/~media/${requestedServiceCode || '~'}/${scope || '~'}/${mediaGroup}~${mediaID}~${mediaRenderedID}/`;
					else 				basePath = `/~media/${requestedServiceCode || '~'}/${scope || '~'}/${mediaGroup}~${mediaID}/`;
				} else {
					if(mediaRenderedID) basePath = `/~media/${mediaGroup}~${mediaID}~${mediaRenderedID}/`;
					else 				basePath = `/~media/${mediaGroup}~${mediaID}/`;
				}

				const path = basePath + filename + '.' + mediaAttributes.extension
				const thumbPath = basePath + filename + '.thumb.' + mediaAttributes.extension

				target.url 		= (url || '') + path
				target.thumb 	= (url || '') + thumbPath

				if(mediaAttributes.mimeType === 'image/svg+xml'){
					target.thumb = target.url
				}
			},

			/**
			 * this function is used to identify the right mediaData for each image given in images and return simplified data.
			 * the function respects the users' breakPoint, the users' device, the configuration of the templateAtom which is in charge and
			 * if to use the layout for assigned or own media according to the actual serviceConfig.
			 *
			 * @param   images                  object - list of images which should be minified to the simplified data.
			 *                                  NOTE: this can be one single image too.
			 * @param   storage                 object - actual storage
			 * @param   imageConfig             object - config object located in templateAtom of the given images (optional)
			 *                                  NOTE:   it is recommended to provide this config to be able to perform
			 *                                          the best possible elimination checks.
			 * @param   requestedServiceCode  	string | boolean - false => ownService, true => webService, string => requestedServiceCode within assignedServices.
			 * @param   preloadDetectedUrls     boolean - if this flag is set to true this function tries to load the images before returning. (default: false)
			 * @param   onImageLoadedCallback   function - if this parameter is a function it will be called without parameters after an image preloading has been done.
			 * @param   containerDimensions     object - dimensions of the container which wants to use this image
			 *                                  NOTE: this can be the components DOM-Representation or the actual window-dimensions.
			 *                                  NOTE: this flag is only set when this is a client side call.
			 * @param   codeNames				String or Array of Strings - return only rendered images according to the given codeNames.
			 * @returns {{
			 *              imageList: [
			 *                  {
			 *                  	mediaID: <mediaID>,
			 *                  	index: <assignment index>,
			 *                      url: <complete url to load image - may be empty string>,
			 *                      thumb: <complete url to load thumb - may be empty string>,
			 *
			 *                  	width: <width - width of original image [px]>,
			 *                  	height: <height - height of original image [px]>,
			 *                  	name: <original filename without extension>,
			 *                  	sizeInBytes: <sizeInBytes>,
			 *                  	extension: <extension without dot>,
			 *                  	permissions: <permissions as in postgres extension: permissions>,
			 *                  	[usedPermissions]: {
			 *                  	 	read: <boolean>,
			 *                  	 	write: <boolean>,
			 *                  	}
			 *                  	exifData: <exifData - may be null>,
			 *                  	createdAt: <createdAt - iso timestamp>,
			 *                  	updatedAt: <updatedAt - iso timestamp>,
			 *
			 *                  	title: <title - may be null - lang dependent>,
			 *                  	alt: <alt - may be null - lang dependent>,
			 *                  	name: <name - may be null - lang dependent>,
			 *                  	info: <info - may be null - lang dependent>,
			 *                  	description: <description - may be null - lang dependent>,
			 *                  	copyright: <copyright - may be null - lang independent>,
			 *
			 *                  	tags: {
			 *                  	 	<tagIndex>: {		// categoryData attributes of tag
			 *                  			sort: <sort integer>,
			 *                  			color: <color - may be null>,
			 *                  			value: <value - may be null>,
			 *                  			config: <config - may be null>,
			 *                  			priority: <priority - may be null>,
			 *                  			categoryID: <categoryID integer>,
			 *                  			categoryDataID: <categoryDataID integer>,
			 *                  			parentCategoryDataID: <parentCategoryDataID - may be null>,
			 *                  			defaultSelected: <defaultSelected - may be null>,
			 *                  			name: <name - may be null - lang dependent>
			 *                  	 	}
			 *                  	},
			 *                  	// rendered may be a codeName separated object of rendered images if there are codenames present (either by config or by parameter)
			 *                  	rendered: {
			 *                  		mediaID: <mediaID>,
			 *                  		mediaRenderedID: <mediaRenderedID>,
			 *                  		url: <url>,
			 *                  		thumb: <thumb>,
			 *                  		title: <title>,
			 *                  		alt: <alt>,
			 *                  		width: <width>,
			 *                  		height: <height>,
			 *                  		class: <class>
			 *                  	}
			 *                  },
			 *                  ...
			 *              ],
			 *              nrOfPreloadingImages: <number of preloading images - use onImageLoadedCallback to handle image dependent code>
			 *           }}
			 */
			detectRendered: function(images, storage, imageConfig, requestedServiceCode = false, preloadDetectedUrls = false, onImageLoadedCallback = null, containerDimensions = null, codeNames = null){
				// init
				const imageList = []
				if(images && images.mediaID){
					images = [images]
				}
				if(!images || utils.collectionSize(images) === 0){
					return {
						imageList:              imageList,
						nrOfPreloadingImages:   0,
					}
				}

				preloadDetectedUrls = !!preloadDetectedUrls
				let device = 'desktop'
				let breakPoint = appConfig.environment.defaultBreakPoint || 'l'
				let breakPointMaxWidth
				let activeBreakPoints
				let clazz
				let forceUrl

				// check preconditions
				if(!storage){
					console.error('missing storage');
					return {
						imageList:              imageList,
						nrOfPreloadingImages:   0,
					};
				}

				// set users' device and breakPoint if possible
				if(((storage.user || {}).data || {}).environment){
					// set default container dimensions if possible
					if(!containerDimensions && storage.user.data.environment.dimensions && storage.user.data.environment.dimensions.window){
						containerDimensions = storage.user.data.environment.dimensions.window;
					}

					if(storage.user.data.environment.device && storage.user.data.environment.device.type){
						device = storage.user.data.environment.device.type;
					}
					if(storage.user.data.environment.breakPoint){
						breakPoint = storage.user.data.environment.breakPoint;
					}
				}


				const {
					layouts = {}
				} = utils.environment.getConfig(storage, requestedServiceCode)

				// check if image preloading is granted by appConfig
				// NOTE: since this is a feature modifying the behaviour of the actual gui only no foreign service config has to be respected.
				if(appConfig.media.preloadImagesGranted === false){
					preloadDetectedUrls = false
				}

				// set active list of breakPoints
				if(!device){
					const firstActiveLayoutKey = Object.keys(layouts).pop()
					if(typeof(layouts[firstActiveLayoutKey]) === 'number' && firstActiveLayoutKey.length() <= 3){
						activeBreakPoints = layouts
					}
				}
				else if(layouts[device]){
					activeBreakPoints = layouts[device]
				}

				// prepare linear list of renderConfigs
				let {
					renderConfigList,
					availableCodeNames,
				} = utils.media.image.extractLinearListOfRenderConfigs(((imageConfig || {}).config || {}).render, layouts, device, activeBreakPoints)

				// prepare codeNames
				if(availableCodeNames.length === 0){
					availableCodeNames = [DEFAULT_RENDERED_IMAGE_CODENAME]
				}
				if(!codeNames) {
					codeNames = availableCodeNames
				} else if(typeof(codeNames) === 'string'){
					codeNames = [codeNames]
				}
				if (!utils.isArray(codeNames)){
					console.error('codeNames of rendered images are not allowed to be anything else but an array')
				}
				for(const [codeNameIndex, codeName] of Object.entries(codeNames)){
					if(utils.indexOf(availableCodeNames, codeName) < 0){
						codeNames.splice(codeNameIndex, 1)
					}
				}
				if(codeNames.length === 0){
					console.error('missing codeNames')
					return {
						imageList:              imageList,
						nrOfPreloadingImages:   0,
					}
				}

				// prepare loading options if necessary
				if(storage.isServer && imageConfig && imageConfig.loadingOptions && (!storage.user.data.serverKnownEnvironment || !storage.user.data.serverKnownEnvironment.skipLoadingOptions)){
					if (imageConfig.loadingOptions.url)         forceUrl    = imageConfig.loadingOptions.url;
					if (imageConfig.loadingOptions['class'])    clazz       = imageConfig.loadingOptions['class'];
				}

				if(!forceUrl){

					// set breakPointMaxWidth if possible
					if(activeBreakPoints && breakPoint && activeBreakPoints[breakPoint]){
						breakPointMaxWidth = activeBreakPoints[breakPoint]
					}

					// check if image preloading is granted by imageConfig
					if(imageConfig && imageConfig.preloadImagesGranted === false){
						preloadDetectedUrls = false
					}
				}

				// sanitize on image loaded callback if necessary
				if(storage.isClient && preloadDetectedUrls && typeof(onImageLoadedCallback) !== 'function'){
					onImageLoadedCallback = function(){}
				}

				// set function essentials
				let nrOfPreloadingImages = 0
				const defaultImageData = {
					mediaID: 0,
					mediaRenderedID: 0,
					url: '',
					thumb: '',
					title: '',
					alt: '',
					name: '',
					width: 0,
					height: 0,
					class: clazz || ''
				};

				// prepare images
				var baseCandidateLists = {
					deviceAndBreakPoint: [],
					device: [],
					breakPoint: [],
					fallback: []
				};
				var c, availableCandidateLists = {};
				for(c in codeNames){
					availableCandidateLists[codeNames[c]] = utils.simpleCopy(baseCandidateLists);
				}
				var previewModeInEffect = (((storage.user || {}).data || {}).serviceCollectionOptions || {}).viewMode === 'preview';

				// estimate candidates
				utils.forEach(images, function(image, imageIndex){
					if(!image.missingMainDBEntry && (!image.pause || previewModeInEffect)){
						var imageListEntry = {};

						// prepare images' renderDetectionMemory
						image.renderDetectionMemory = {
							candidateList: 		{},
							candidateListType: 	{},
							candidateLists: 	utils.simpleCopy(availableCandidateLists),
							candidateData: 		utils.simpleCopy(defaultImageData)
						}

						// prepare image data
						image.renderDetectionMemory.candidateData.mediaID = image.mediaID;
						if(image.title) image.renderDetectionMemory.candidateData.title = image.title;
						if(image.alt) 	image.renderDetectionMemory.candidateData.alt 	= image.alt;
						if(image.name) 	image.renderDetectionMemory.candidateData.name 	= image.name;

						if(forceUrl){
							if(!codeNames || (codeNames.length === 1 && codeNames[0] === DEFAULT_RENDERED_IMAGE_CODENAME)){
								imageList.push(utils.replace(image.renderDetectionMemory.candidateData, {
									url:    forceUrl,
									thumb:  ''
								}));
							} else {
								imageListEntry = {};
								for(c in codeNames){
									imageListEntry[codeNames[c]] = utils.replace(image.renderDetectionMemory.candidateData, {
										url:   	 	forceUrl,
										thumb:  	'',
										codeName: 	codeNames[c]
									});
								}
								imageList.push(imageListEntry);
							}
						}
						else {
							// use rendered image if possible
							if(image.rendered){
								utils.forEach(image.rendered, function(renderedImage){
									utils.forEach(image.renderDetectionMemory.candidateLists, function(candiateLists, codeName){
										if(
											codeName === DEFAULT_RENDERED_IMAGE_CODENAME
											||
											(
												!renderedImage.codeName &&
												utils.media.image.renderedMatchesOneConfig(renderedImage, renderConfigList, codeName, breakPoint, device)
											)
											||
											renderedImage.codeName === codeName
										){
											if(renderedImage.device === device){
												if(renderedImage.breakPoint === breakPoint){
													image.renderDetectionMemory.candidateLists[codeName].deviceAndBreakPoint.push(renderedImage);
												}
												else {
													image.renderDetectionMemory.candidateLists[codeName].device.push(renderedImage);
												}
											}
											else if(renderedImage.breakPoint === breakPoint){
												image.renderDetectionMemory.candidateLists[codeName].breakPoint.push(renderedImage);
											}
											else {
												image.renderDetectionMemory.candidateLists[codeName].fallback.push(renderedImage);
											}
										}
									});
								});
							}

							// choose candidateList
							utils.forEach(image.renderDetectionMemory.candidateLists, function(candidateLists, codeName){
								utils.forEach(candidateLists, function(candidateList, candidateType){
									if(candidateList.length > 0){
										image.renderDetectionMemory.candidateList[codeName]     = candidateList;
										image.renderDetectionMemory.candidateListType[codeName] = candidateType;
										return false;
									}
								});
							});

							// list of chosen image candidates per codeName
							imageListEntry = {};
							utils.forEach(codeNames, function(codeName){
								var candidateList = image.renderDetectionMemory.candidateList[codeName] || [];
								var realCodeName;
								var loadImage;
								if(codeName !== DEFAULT_RENDERED_IMAGE_CODENAME) realCodeName = codeName;

								// take main image
								if(candidateList.length <= 0){
									imageListEntry[codeName] = utils.replace(image.renderDetectionMemory.candidateData, {
										url:    	image.url,
										thumb:  	image.thumb,
										codeName: 	realCodeName
									});
								}
								// take single candidate
								else if(candidateList.length === 1){
									imageListEntry[codeName] = utils.replace(image.renderDetectionMemory.candidateData, {
										url:    			candidateList[0].url,
										thumb:  			candidateList[0].thumb,
										width:  			candidateList[0].width,
										height: 			candidateList[0].height,
										codeName: 			realCodeName,
										mediaRenderedID: 	candidateList[0].mediaRenderedID
									});
								}
								// choose from multiple available candidates
								else {
									var candidate;
									var candidateIdentified = false;
									var bestCandidates = Object.keys(candidateList);
									var distanceList;
									var distance;
									var minDistanceGreaterThanZero;
									var maxDistanceLowerThanZero;
									var c;
									var check;
									var checks = [];
									var usedDevice;
									var usedBreakPoint;

									// check imageConfig conditions
									if(imageConfig){
										if(imageConfig.maxWidth){
											// check if candidates meet size conditions according to imageConfig
											if(typeof(imageConfig.maxWidth) === 'number'){
												checks.push('imageConfig.maxWidth.simple');
											}
											else if(typeof(imageConfig.maxWidth) === 'object' && utils.collectionSize(imageConfig.maxWidth) > 0){
												var firstMaxWidthKey = Object.keys(imageConfig.maxWidth).pop();

												if(typeof(imageConfig.maxWidth[firstMaxWidthKey]) === 'number'){
													// check if candidates meet breakPoint-size conditions according to imageConfig
													if(firstMaxWidthKey.length() <= 3){
														checks.push('imageConfig.maxWidth.breakPoint');
													}
													// check if candidates meet device-size conditions according to imageConfig
													else {
														checks.push('imageConfig.maxWidth.device');
													}
												}
												// check if candidates meet device-breakPoint-size conditions according to imageConfig
												else {
													checks.push('imageConfig.maxWidth.deviceAndBreakPoint');
												}
											}
										}
									}

									// no full match found => eliminate elements which have not lowest breakPoint-distance
									if(activeBreakPoints && breakPointMaxWidth && (image.renderDetectionMemory.candidateListType[codeName] === 'device' || image.renderDetectionMemory.candidateListType[codeName] === 'fallback')) {
										checks.push('layout.breakPointDistance');
									}

									// check container dimensions
									if(containerDimensions){
										checks.push('container.dimensions');
									}

									// check container dimensions
									checks.push('fallback.biggestFirst');

									// perform all listed checks
									for(var checkIndex in checks){
										// init check
										check = checks[checkIndex];
										distanceList = {};
										minDistanceGreaterThanZero = Number.MAX_SAFE_INTEGER;
										maxDistanceLowerThanZero = Number.MIN_SAFE_INTEGER;

										// check all candidates left
										for(c in bestCandidates) {
											candidate = candidateList[bestCandidates[c]];

											switch(check){
												case 'imageConfig.maxWidth.simple':
													distance = imageConfig.maxWidth - candidate.width;
													break;

												case 'imageConfig.maxWidth.breakPoint':
													// check against imageConfig which is assigned to users' breakpoint
													if(breakPoint && imageConfig[breakPoint]) {
														distance = imageConfig[breakPoint] - candidate.width;
													}
													// check against imageConfig which is assigned to images' breakpoint
													else if(candidate.breakPoint && imageConfig[candidate.breakPoint]) {
														distance = imageConfig[candidate.breakPoint] - candidate.width;
													}
													else {
														continue;
													}
													break;

												case 'imageConfig.maxWidth.device':
													// check against imageConfig which is assigned to users' device
													if(device && imageConfig[device]) {
														distance = imageConfig[device] - candidate.width;
													}
													// check against imageConfig which is assigned to images' device
													else if(candidate.device && imageConfig[candidate.device]) {
														distance = imageConfig[candidate.device] - candidate.width;
													}
													else {
														continue;
													}
													break;

												case 'imageConfig.maxWidth.deviceAndBreakPoint':
													usedDevice = undefined;
													usedBreakPoint = undefined;

													if(device && imageConfig[device])                           usedDevice = device;
													else if(candidate.device && imageConfig[candidate.device])  usedDevice = candidate.device;

													if(usedDevice){
														if(breakPoint && imageConfig[usedDevice][breakPoint])                           usedBreakPoint = breakPoint;
														else if(candidate.breakPoint && imageConfig[usedDevice][candidate.breakPoint])  usedBreakPoint = candidate.breakPoint;

														if(usedBreakPoint){
															distance = imageConfig[usedDevice][usedBreakPoint] - candidate.width;
														}
														else {
															continue;
														}
													}
													else {
														continue;
													}
													break;


												case 'layout.breakPointDistance':
													if(candidate.breakPoint && activeBreakPoints[candidate.breakPoint]) {
														distance = breakPointMaxWidth - activeBreakPoints[candidate.breakPoint];
													}
													else {
														continue;
													}
													break;

												case 'container.dimensions':
													distance = containerDimensions.width - candidate.width;
													break;

												case 'fallback.biggestFirst':
													distance = candidate.width - Number.MAX_SAFE_INTEGER;
													break;
											}

											if(distanceList[distance] === undefined){
												distanceList[distance] = [];
											}
											distanceList[distance].push(c);
											if(distance > 0){
												minDistanceGreaterThanZero = Math.min(minDistanceGreaterThanZero, distance);
											}
											else if(distance < 0) {
												maxDistanceLowerThanZero = Math.max(maxDistanceLowerThanZero, distance);
											}
										}

										// take candidates matching the wanted maxWidth
										if(distanceList[0]){
											bestCandidates = distanceList[0];
										}
										// take candidates which are slightly greater than the wanted maxWidth
										else if(maxDistanceLowerThanZero > Number.MIN_SAFE_INTEGER){
											bestCandidates = distanceList[maxDistanceLowerThanZero];
										}
										// take candidates which are slightly smaller than the wanted maxWidth
										else if(minDistanceGreaterThanZero < Number.MAX_SAFE_INTEGER){
											bestCandidates = distanceList[minDistanceGreaterThanZero];
										}

										if(bestCandidates.length <= 0){
											console.error('error during check[' + check + '] in multiple-candidates-problem');
										}
										else if(bestCandidates.length == 1){
											candidateIdentified = true;
											imageListEntry[codeName] = utils.replace(image.renderDetectionMemory.candidateData, {
												url:    			candidateList[bestCandidates[0]].url,
												thumb:  			candidateList[bestCandidates[0]].thumb,
												width:  			candidateList[bestCandidates[0]].width,
												height: 			candidateList[bestCandidates[0]].height,
												codeName: 			realCodeName,
												mediaRenderedID: 	candidateList[bestCandidates[0]].mediaRenderedID
											});
											break;
										}
									}

									// error handling
									if(!candidateIdentified){
										console.error('imageList not complete according to multiple-candidates-problem');

										// choose first one as global fallback
										// candidateIdentified = true;
										imageListEntry[codeName] = utils.replace(image.renderDetectionMemory.candidateData, {
											url:    			candidateList[bestCandidates[0]].url,
											thumb:  			candidateList[bestCandidates[0]].thumb,
											width:  			candidateList[bestCandidates[0]].width,
											height: 			candidateList[bestCandidates[0]].height,
											codeName: 			realCodeName,
											mediaRenderedID: 	candidateList[bestCandidates[0]].mediaRenderedID
										});
									}
								}

								// load image if necessary
								if(storage.isClient && preloadDetectedUrls && imageListEntry[codeName] && !imageListEntry[codeName].preloaded){
									nrOfPreloadingImages++;
									imageListEntry[codeName].preloaded = true;
									loadImage = new Image();
									loadImage.onload = onImageLoadedCallback;
									loadImage.onerror = onImageLoadedCallback;
									loadImage.src = imageListEntry[codeName].url;
								}
							});

							if(utils.collectionSize(imageListEntry) > 0){
								var chosenImageListEntry;
								if(codeNames.length === 1 && codeNames[0] === DEFAULT_RENDERED_IMAGE_CODENAME){
									chosenImageListEntry = imageListEntry[DEFAULT_RENDERED_IMAGE_CODENAME];
								} else {
									chosenImageListEntry = imageListEntry;
								}

								// utils.replace is not used for deletion only.
								// additionally it is used to prevent referential changes within the modelField.
								imageList.push(utils.replace(image, {
									renderDetectionMemory: 	undefined,
									tagsResources: 			undefined,
									cms_mediaTrl: 			undefined,
									data: 					undefined,

									rendered: 				chosenImageListEntry
								}));
							}
						}
					}
				});

				return {
					imageList:              imageList,
					nrOfPreloadingImages:   nrOfPreloadingImages
				};
			},

			/**
			 * remove unnecessary flags from assignmentMedia right before it will be written to the database
			 *
			 * @param media
			 * @returns mediaData needed for assignment (e.g., dataJSON of templateAtom)
			 */
			cleanupElementBeforeSet: function(media){
				media = media || {};
				var renderedImageIndex, rendered = [];
				for(renderedImageIndex in media.rendered || []){
					if(media.rendered[renderedImageIndex].mediaRenderedID){
						rendered.push({
							mediaRenderedID: media.rendered[renderedImageIndex].mediaRenderedID
						});
					}
				}
				var result = {
					mediaID: 	media.mediaID,
					data: 		media.data,
					rendered: 	rendered
				}
				if(media.pause === true){
					result.pause = true;
				}
				return result;
			},

			/**
			 * this function returns the maximum dimensions needed for a given image-config parameter.
			 *
			 * @param   imageConfig     		object - actual image config used within the template-atom of an image
			 * @param   activeMediaConfig       object - activeMediaConfig defined by service
			 * @return  {
			 *              width: number,
			 *              height: number
			 *          }
			 */
			detectMaxDimensions: function(imageConfig, activeMediaConfig){
				if(!imageConfig || !imageConfig.render) return { width: 0, height: 0 };

				var act;
				var max = {
					width: 0,
					height: 0
				};

				var activeBreakPoints;
				// set active list of breakPoints if possible
				if((activeMediaConfig || {}).layout){
					var firstActiveLayoutKey = Object.keys(activeMediaConfig.layout).pop();
					if(typeof(activeMediaConfig.layout[firstActiveLayoutKey]) === 'number' && firstActiveLayoutKey.length() <= 3){
						activeBreakPoints = activeMediaConfig.layout;
					}
				}

				// prepare linear list of renderConfigs
				var extractedLinearListOfRenderConfigs 	= utils.media.image.extractLinearListOfRenderConfigs((imageConfig || {}).render, activeMediaConfig, undefined, activeBreakPoints);
				var renderConfigList 					= (extractedLinearListOfRenderConfigs || {}).renderConfigList;

				// use renderConfigList each time possible.
				// NOTE: the other cases are merely fallbacks than really necessary
				if ((renderConfigList || []).length > 0){
					for(var rc in renderConfigList){
						act = utils.media.image.detectMaxConfigDimensions(renderConfigList[rc]);
						max.width = Math.max(act.width, max.width);
						max.height = Math.max(act.height, max.height);
					}
				}
				else if(imageConfig.devices){
					if(imageConfig.breakPoints){
						for(var device in imageConfig.render){
							for(var breakPoint in imageConfig.render[device]){
								act = utils.media.image.detectMaxConfigDimensions(imageConfig.render[device][breakPoint]);
								max.width = Math.max(act.width, max.width);
								max.height = Math.max(act.height, max.height);
							}
						}
					}
					else {
						for(var device in imageConfig.render){
							act = utils.media.image.detectMaxConfigDimensions(imageConfig.render[device]);
							max.width = Math.max(act.width, max.width);
							max.height = Math.max(act.height, max.height);
						}
					}
				}
				else if(imageConfig.breakPoints) {
					for(var breakPoint in imageConfig.render[device]){
						act = utils.media.image.detectMaxConfigDimensions(imageConfig.render[breakPoint]);
						max.width = Math.max(act.width, max.width);
						max.height = Math.max(act.height, max.height);
					}
				}
				else {
					act = utils.media.image.detectMaxConfigDimensions(imageConfig.render);
					max.width = Math.max(act.width, max.width);
					max.height = Math.max(act.height, max.height);
				}

				return max;
			},

			/**
			 * this function returns the maximum width and height needed by a given renderConfig.
			 *
			 * @param   renderConfig        object - renderConfig of a media-render-call
			 * @return  {
			 *              width: number,
			 *              height: number
			 *          }
			 */
			detectMaxConfigDimensions: function(renderConfig){
				if(renderConfig.type === 'dynamic'){
					return {
						width:  renderConfig.maxWidth || renderConfig.minWidth || 0,
						height: renderConfig.maxHeight || renderConfig.minHeight || 0
					}
				}

				return {
					width:  renderConfig.width || 0,
					height: renderConfig.height || 0
				}
			},

			/**
			 * this function returns a list of renderImageConfigs which are needed to render an image according to the given imageConfig.
			 * NOTE: in case of incomplete parameters or definitions the function will return an empty list.
			 *
			 * @param   image                   object - mediaImage
			 * @param   imageConfig             object - mediaImageConfig
			 * @param   activeMediaConfig       object - activeMediaConfig defined by service
			 * @param   activeEnvironment       object - activeEnvironment
			 * @return  [{<renderImageConfig>}, ...]
			 */
			prepareRenderConfigs: function(image, imageConfig, activeMediaConfig, activeEnvironment){
				var renderConfigs = [];
				if(image && imageConfig && imageConfig.render && !utils.isEmpty(imageConfig.render)){
					// prepare helper data
					var device, activeBreakPoints = [];
					if(((activeEnvironment || {}).device || {}).type) 				device = activeEnvironment.device.type;
					if(device && ((activeMediaConfig || {}).layout || {})[device]) 	activeBreakPoints = activeMediaConfig.layout[device];

					// prepare renderConfigs
					renderConfigs = utils.media.image.extractLinearListOfRenderConfigs(imageConfig.render, activeMediaConfig, device, activeBreakPoints).renderConfigList || [];

					// set mediaID in configs
					var rc;
					for(rc in renderConfigs){
						renderConfigs[rc].mediaID = image.mediaID;
					}
				}

				return renderConfigs;
			},

			/**
			 * this function returns a linear list of all renderConfigs found within the given renderConfig param and
			 * a list of available codeNames used within them.
			 *
			 * @param renderConfig				object - renderConfig defined by templateAtom
			 * @param activeMediaConfig			object - active media config defined by service
			 * @param device					string - optional - actual device code
			 * @param activeBreakPoints			array - optional - list of active breakPoints (e.g., within the given device) defined by service
			 * @param recursionStorage			object - used for function internal logic.
			 * 									NOTE: never ever define this param from outside!
			 * @returns {{
			 * 				availableCodeNames: [],
			 * 				renderConfigList: 	[
			 * 				 	{
			 * 				 	  <oneSingleRenderConfigParams>,
			 * 				 	  device: <device>,
			 * 				 	  breakPoint: <breakPoint>,
			 * 				 	  codeName: <codeName>
			 * 				 	}, ...
			 * 				]
			 * 			}}
			 */
			extractLinearListOfRenderConfigs: function(renderConfig, layouts, device, activeBreakPoints, recursionStorage){
				// init
				if(!recursionStorage) 						recursionStorage = {};
				if(!recursionStorage.state) 				recursionStorage.state = {};
				if(!recursionStorage.configList) 			recursionStorage.configList = [];
				if(!recursionStorage.availableCodeNames) 	recursionStorage.availableCodeNames = [];
				if(!recursionStorage.supportedDevices) {
					recursionStorage.supportedDevices = []
					if(layouts){
						recursionStorage.supportedDevices = Object.keys(layouts)
					}
				}
				if(!recursionStorage.supportedBreakPoints) {
					recursionStorage.supportedBreakPoints = []
					if(activeBreakPoints){
						recursionStorage.supportedBreakPoints = Object.keys(activeBreakPoints)
					}
				}

				if(renderConfig && utils.collectionSize(renderConfig) > 0){

					// single config
					if(
						renderConfig.type ||
						renderConfig.width ||
						renderConfig.height ||
						renderConfig.minWidth ||
						renderConfig.maxWidth
					){
						renderConfig.device 	= device
						renderConfig.breakPoint = recursionStorage.state.breakPoint
						renderConfig.codeName 	= recursionStorage.state.codeName
						recursionStorage.configList.push(utils.simpleCopy(renderConfig))
					}
					// multiple configs
					else {
						for(const [configID, config] of Object.entries(renderConfig)){
							// is device
							if(utils.indexOf(recursionStorage.supportedDevices, configID) > -1){
								recursionStorage.state.device = configID
								utils.media.image.extractLinearListOfRenderConfigs(config, layouts, device, activeBreakPoints, recursionStorage)
								delete recursionStorage.state.device
							}
							// is breakpoint
							else if(utils.indexOf(recursionStorage.supportedBreakPoints, configID) > -1){
								recursionStorage.state.breakPoint = configID
								utils.media.image.extractLinearListOfRenderConfigs(config, layouts, device, activeBreakPoints, recursionStorage);
								delete recursionStorage.state.breakPoint
							}
							// is codename
							else {
								if(utils.indexOf(recursionStorage.availableCodeNames, configID) < 0){
									recursionStorage.availableCodeNames.push(configID)
								}
								recursionStorage.state.codeName = configID
								utils.media.image.extractLinearListOfRenderConfigs(config, layouts, device, activeBreakPoints, recursionStorage)
								delete recursionStorage.state.codeName
							}
						}
					}
				}

				return {
					availableCodeNames: recursionStorage.availableCodeNames,
					renderConfigList: recursionStorage.configList,
				}
			},

			/**
			 * this function returns true if the given renderedImage matches at least one single renderConfig defined by
			 * the renderConfigList param.
			 *
			 * @param renderedImage			object - renderedImage to check for a match
			 * @param renderConfigList		array - linear renderConfigList
			 * 								NOTE: renderConfigList has to be linear (@see utils.media.image.extractLinearListOfRenderConfigs method)
			 * @param codeName				string - optional - actual codeName you are looking for
			 * @param breakPoint			string - optional - actual breakPoint you are looking for
			 * @param device				string - optional - actual device your are looking for
			 * @returns {boolean} matchFound?
			 */
			renderedMatchesOneConfig: function(renderedImage, renderConfigList, codeName, breakPoint, device){
				if(!renderedImage) return false;
				if(!renderConfigList || utils.collectionSize(renderConfigList) < 1) return false;

				var rc, renderConfig;
				for(rc in renderConfigList){
					renderConfig = renderConfigList[rc];

					if(
						(!renderConfig.codeName		|| codeName === renderConfig.codeName) &&
						(!renderConfig.device 		|| device === renderConfig.device) &&
						(!renderConfig.breakPoint 	|| breakPoint === renderConfig.breakPoint) &&
						// image dimension checks
						(
							// dynamic
							(
								renderConfig.type === 'dynamic' &&
								(renderConfig.minWidth <= 0 || renderedImage.width >= renderConfig.minWidth) &&
								(renderConfig.maxWidth <= 0 || renderedImage.width <= renderConfig.maxWidth)
							)
							||
							// fixed
							(
								(!renderConfig.type || renderConfig.type === 'fixed') &&
								(!renderConfig.width || renderConfig.width <= 0 || renderedImage.width === renderConfig.width) &&
								(!renderConfig.height || renderConfig.height <= 0 || renderedImage.height === renderConfig.height)
							)
						)
					){
						return true;
					}
				}

				return false;
			}
		}
	},

	routes: {
		prepare: function(route, storage){
			var resourceRoute = route.resource || {};

			// set core data
			route.url 		= resourceRoute.path;
			route.visible	= resourceRoute.visible;
			route.langCode 	= resourceRoute.langCode;
			route.tags 		= resourceRoute.tags || {};

			// prepare tags
			var usedLangCode = route.langCode || storage.langCode || ((appConfig || {}).language || {}).default
			var categoryID, categoryDataID;
			var category, categoryData;
			for(categoryID in route.tags){
				category = route.tags[categoryID];
				if((category.trls || {})[usedLangCode]){
					category.langCode = usedLangCode;
					utils.refReplace(category, category.trls[usedLangCode]);
				}
				delete category.trls;

				for(categoryDataID in category.tags){
					categoryData = category.tags[categoryDataID];
					if((categoryData.trls || {})[usedLangCode]){
						categoryData.langCode = usedLangCode;
						utils.refReplace(categoryData, categoryData.trls[usedLangCode]);
					}
					delete categoryData.trls;
				}
			}

			// cleanup
			delete route.resource;
		},
	},

	tags: {

		/**
		 * iterates over all categories within the given tagPickerObject.
		 *
		 * @param tagPickerObject		object - usually the model.field of a tag-picker
		 * @returns {Generator<unknown, void, *>}
		 */
		*eachCategory(tagPickerObject){
			for(const category of Object.values((tagPickerObject || {}).options || {})){
				if(category){ // prevent null fields
					yield category
				}
			}
		},

		// TODO: docs format of return value?!?
        /**
         * iterates over all tags (categoryDatas) within the categories within the given tagPickerObject.
         *
         * @param tagPickerObject		object - usually the model.field of a tag-picker
         * @returns {Generator<unknown, void, *>}
         */
		*each(tagPickerObject){
			for(const category of this.eachCategory(tagPickerObject)){
				for(const tag of Object.values(category.children || {})){
					if(tag){ // prevent null fields
						yield {tag, category}
					}
				}
			}
		},

		/**
		 * iterates over all tags (categoryDatas) just like this.each() does but only if they have been assigned
		 * either within the given assignedTagList if given  or within the dataJSON field of the given tagPickerObject otherwise.
		 *
		 * @param tagPickerObject		object - usually the model.field of a tag-picker
		 * @param [assignedTagList]		array - assigned tags. e.g., ['<categoryID>_<categoryDataID>', ...]
		 * @returns {Generator<unknown, void, *>}
		 */
		*eachAssigned(tagPickerObject, assignedTagList = null){
			const {dataJSON} = tagPickerObject || {}

			// prepare tagKeys lookup
			const tagKeys = {}
			for(const tagKey of Object.values(assignedTagList || dataJSON || [])){
				tagKeys[tagKey] = true
			}

			// yield entries
			for(const {tag, category} of this.each(tagPickerObject)){
				if(tagKeys[tag.tagKey || 'MISSING_KEY_TAG']){
					yield {tag, category}
				}
			}
		},
	},

	fields: {

		/**
		 * prepare resource pickers data according to given resourceData param.
		 *
		 * @param modelField					object - reference to right modelField
		 * @param resourceTargetModelField 		object - reference to modelField where the data should be stored
		 * 										NOTE: may differ according to isPicked flag.
		 * @param resourceData					object - resourceData given by resourceAction (or serverside preloaded resourceData)
		 * @param storage						object - actual storage
		 * @param resourceLoader				object - reference on resourceLoader used for picking
		 */
		prepareResourcePicker: function(modelField, resourceTargetModelField, resourceData, storage, resourceLoader){
			if(!modelField['resource-picker-data']) modelField['resource-picker-data'] = {};
			resourceLoader = resourceLoader || {}
			resourceTargetModelField = resourceTargetModelField || {}

			if((modelField.config || {}).preventResourcePickerDataPreparation){
				utils.forEach(resourceData, function(resources, resourceType){
					modelField['resource-picker-data'][resourceType] = resources;
				});
			} else {
				var options = [];
				var value, name, title;

				// prepare fields which are needed within the value and name params
				var preparedFields = {};
				var matches;
				if((matches = (((modelField.config || {}).value || '') + ((modelField.config || {}).name || '') + ((modelField.config || {}).title || '')).match(/{[\w_\-\d]+}/g))){
					for(var i in matches){
						preparedFields[matches[i].replace(/[{}]/g, '')] = new RegExp(matches[i], 'g');
					}
				}

				if((resourceData || {}).data){
					utils.forEach(Array.isArray(resourceData.data) ? resourceData.data : [resourceData.data], data => {
						// define by values for value and name
						if(modelField.config.value) value = modelField.config.value + '';
						else                        value = data.attributes[data.primaryKey] + '';
						if(modelField.config.name)  name = modelField.config.name;
						else                        name = 'noNameFound';
						if(modelField.config.title) title = modelField.config.title;
						else                        title = name;

						// replace all fields within the strings
						utils.forEach(preparedFields, function(fieldRegExp, fieldKey){
							value   = value.replace(fieldRegExp, data.attributes[fieldKey] || '');
							name    = name.replace(fieldRegExp, data.attributes[fieldKey] || '');
							title 	= title.replace(fieldRegExp, data.attributes[fieldKey] || '');
						});

						// add option
						options.push({
							resource: 			data,
							title: 				title,
							name: 				name,
							value: 				value,
							lang: 				data.attributes.lang || {},
							defaultSelected: 	value == modelField.config.defaultSelected
						});
					});
				}

				// set options
				modelField['resource-picker-data'].options = options;
			}

		},

		/**
		 * prepare tag pickers data according to given resourceData param.
		 *
		 * @param modelField					object - reference to right modelField
		 * @param resourceTargetModelField 		object - reference to modelField where the data should be stored
		 * 										NOTE: may differ according to isPicked flag.
		 * @param resourceData					object - resourceData given by resourceAction (or serverside preloaded resourceData)
		 * @param storage       				object - actual storage
		 * @param resourceLoader				object - reference on resourceLoader used for picking
		 * @param [actualScope]					string - actual components' scope
		 */
		prepareTagPicker: function(modelField, resourceTargetModelField, resourceData, storage, resourceLoader, actualScope){
			resourceLoader = resourceLoader || {}
			resourceTargetModelField = resourceTargetModelField || {}

			let target
			if(resourceLoader.isPicked){
				target = resourceTargetModelField
			} else {
				if(!resourceTargetModelField['tag-picker-data']) resourceTargetModelField['tag-picker-data'] = {};
				target = resourceTargetModelField['tag-picker-data']
			}

			const categoriesOptions = {}
			resourceData = resourceData || {}

			// TODO: POIA: CLEANUP
			// var tagScopeCategories = (((resourceData.data || {}).children || {}).cms_tagScopes_categories || {}).data || [];
			// var inheritedCategories = utils.prepareTagCategoryInheritanceList(resourceData.routes, resourceData.routeTags, 'parentRouteID');
			const inheritedCategories = {}
			utils.prepareCategories(categoriesOptions, resourceData.data || [], storage, inheritedCategories, actualScope);

			// // prepare scope dependent categories
			// utils.forEach(tagScopeCategories, function(tagScopeCategory){
			// 	var categories = ((tagScopeCategory.children || {}).cms_categories || {}).data || [];
			// 	utils.prepareCategories(categoriesOptions, {}, categories, storage, inheritedCategories, actualScope);
			// });

			// prepare actually assigned tags in case of dataFormat === 'array' if possible
			// const assignedTagIndexList = {}
			// for(let tagKey of Object.values(target.dataJSON || [])){
			// 	tagKey = String(tagKey || '').trim()
			// 	if(refTags[tagKey]){
			// 		preparedAssignedTags[tagKey] = refTags[tagKey]
			// 	}
			// }

			// set options
			target.ts 					= new Date().toISOString()
			target.options 				= categoriesOptions
			target.inheritedCategories 	= inheritedCategories
			// target.tagIndexList			= refTagIndexList
			// target.preparedAssignedTags = preparedAssignedTags


			// TODO: consider result preparation for resourceTargetModelField just like category picker does.
		},

		/**
		 * prepare resource pickers data according to given resourceData param.
		 *
		 * @param modelField					object - reference to right modelField
		 * @param resourceTargetModelField 		object - reference to modelField where the data should be stored
		 * 										NOTE: may differ according to isPicked flag.
		 * @param resourceData					object - resourceData given by resourceAction (or serverside preloaded resourceData)
		 * @param storage						object - actual storage
		 * @param resourceLoader				object - reference on resourceLoader used for picking
		 */
		prepareRoutePicker: function(modelField, resourceTargetModelField, resourceData, storage, resourceLoader){
			//////////////// VALID OPTIONS ///////////////////
			//// pickedRouteID: 		1
			//// includePickedRoute: 	false
			//// levels: 				2
			//// prepareFullOptions: 	true
			//// hideInactivesOnly: 	false
			//// preventStatusCheck: 	false
			//////////////////////////////////////////////////

			if(!resourceData) 					resourceData = {}
			if(!resourceData.fec) 				resourceData.fec = {}
			if(!resourceData.fec.routes) 		resourceData.fec.routes = {}
			if(!resourceData.fec.routeParents) 	resourceData.fec.routeParents = {}

			resourceLoader = resourceLoader || {};
			resourceTargetModelField = resourceTargetModelField || {};
			var options = [];
			var routeParents = resourceData.fec.routeParents;
			var routes = resourceData.fec.routes;
			var route;
			var grantedRoutes = {};
			var fieldConfig = (modelField || {}).config || {};
			var prepareFullOptions = fieldConfig.prepareFullOptions === true || (((storage || {}).app || {}).service || {}).applicationType === 'cms';
			var hideInactivesOnly = fieldConfig.hideInactivesOnly === true;
			var preventStatusCheck = fieldConfig.hideInactivesOnly === true;
			var baseLevel = 0;
			var routeID;
			var target;

			if(resourceLoader.isPicked){
				target = resourceTargetModelField;
			} else {
				if(!resourceTargetModelField['route-picker-data']) resourceTargetModelField['route-picker-data'] = {};
				target = resourceTargetModelField['route-picker-data'];
			}

			var targetData = target.data;
			if(targetData === undefined && target.dataJSON !== undefined) targetData = target.dataJSON;

			// no need to prepare anything?
			if (utils.isEmpty(targetData) && !prepareFullOptions) {
				return;
			}

			if(utils.collectionSize(resourceData.data) > 0 && utils.collectionSize(routeParents) == 0){
				// sort resources by tree sort logic
				utils.sortTreeResources(resourceData, 'parentRouteID', routeParents);
			}

			if(utils.collectionSize(resourceData.data) > 0 && utils.collectionSize(routes) == 0){
				// collect id indexed list
				for(var dataIndex in (resourceData || {}).data || []){
					var route = ((resourceData || {}).data || [])[dataIndex];

					if((route || {}).attributes){
						routes[route.attributes[route.primaryKey || 'id']] = dataIndex;
					}
				}
			}

			if(fieldConfig.pickedRouteID) {
				fieldConfig.pickedRouteID = parseInt(fieldConfig.pickedRouteID);
				baseLevel = utils.collectionSize(routeParents[fieldConfig.pickedRouteID]);
			}

			// collect list of granted routeIDs (level and pickedRouteID restrictions)
			for (var routeID in routeParents){
				var routeParentsPerLevel = routeParents[routeID];

				route = (resourceData.data[routes[routeID]] || {}).attributes || {};
				if(
					// picked route check
					(
						!fieldConfig.pickedRouteID
						||
						(
							routeID == fieldConfig.pickedRouteID
							&&
							fieldConfig.includePickedRoute
						)
						||
						(
							utils.indexOf(routeParentsPerLevel, fieldConfig.pickedRouteID) > -1
						)
					)
					&&
					// level check
					(
						!fieldConfig.levels
						||
						((utils.collectionSize(routeParentsPerLevel) - baseLevel) <= fieldConfig.levels)
					)
				){
					grantedRoutes[routeID] = true;
				}
			}

			// collection granted options
			for (var dataIndex in (resourceData || {}).data || []){
				var route = resourceData.data[dataIndex];

				if(grantedRoutes[(routeID = (route || {}).attributes[(route || {}).primaryKey || 'id'])]){
					route.attributes.id = routeID;
					if (prepareFullOptions) {
						options.push(route.attributes);
					}
				}
			}

			// set options
			if (prepareFullOptions) {
				target.options = options;
			}

			// set result according to given data and options
			if(targetData){
				var option, o;
				var d, dataElements = [];
				var isList = false;

				if(utils.isCollection(targetData)){
					dataElements = targetData;
					target.result = {};
					isList = true;
				} else {
					dataElements = [targetData];
				}

				var userReferenceTS = storage.user.getReferenceTS();

				for(d in dataElements){
					routeID = dataElements[d];
					if(routeID && grantedRoutes[routeID] && (option = (resourceData.data[routes[routeID] || 0] || {}).attributes) && routeID == (option.routeID || option.id || false)){
						option.id = parseInt(routeID);
						// estimate minFuturePeriodChangeAt timestamp
						if((option.periodStart && option.periodStart > userReferenceTS && (!storage.request.minFuturePeriodChangeAt || storage.request.minFuturePeriodChangeAt > option.periodStart))){
							storage.request.minFuturePeriodChangeAt = option.periodStart;
						}
						if((option.periodEnd && option.periodEnd > userReferenceTS && (!storage.request.minFuturePeriodChangeAt || storage.request.minFuturePeriodChangeAt > option.periodEnd))){
							storage.request.minFuturePeriodChangeAt = option.periodEnd;
						}

						if(
							// status check
							preventStatusCheck
							||
							(
								option.status !== 'inactive'
								&&
								hideInactivesOnly
							)
							||
							(
								(
									(
										storage.user
										&&
										utils.isFunction(storage.user.statusVisible)
										&&
										storage.user.statusVisible(option.status)
									)
									||
									(
										(
											utils.isEmpty(option.status)
											||
											option.status === 'active'
											||
											option.status === 'preview & active'
											||
											option.status === 'invisible'
										)
									)
								)
								&&
								// period check
								(
									(
										!option.periodStart
										||
										userReferenceTS >= option.periodStart
									)
									&&
									(
										!option.periodEnd
										||
										userReferenceTS <= option.periodEnd
									)
								)
							)
						){
							if(isList){
								target.result[routeID] = option;
							} else {
								target.result = option;
							}
						}
					}
				}

				// deprecated: backwards compatibility of limited options
				if (!prepareFullOptions && target.result) {
					if(isList){
						target.options = Object.values(target.result);
					} else {
						target.options = [target.result];
					}
				}
			}
		},

		/**
		 * prepare routePickerFull data according to given resourceData param. (urls, tags, ...)
		 *
		 * @param modelField					object - reference to right modelField
		 * @param resourceTargetModelField 		object - reference to modelField where the data should be stored
		 * 										NOTE: may differ according to isPicked flag.
		 * @param resourceData					object - resourceData given by resourceAction (or serverside preloaded resourceData)
		 * @param storage						object - actual storage
		 * @param resourceLoader				object - reference on resourceLoader used for picking
		 * @param componentInstance				object - in case of html link replacements the componentInstance is necessary to replace the model field data by reference
		 */
		prepareRoutePickerFull: function(modelField, resourceTargetModelField, resourceData, storage, resourceLoader, componentInstance){
			resourceTargetModelField = resourceTargetModelField || {};
			resourceData = resourceData || {};
			resourceLoader = resourceLoader || {};
			var routeIndex;
			var assignedRoutes, r, refRoute, route, routeID, routeAttributes;
			var resourceTargetModelFieldData;

			if(resourceLoader.isPicked){
				resourceTargetModelFieldData = resourceTargetModelField;
			} else if(resourceLoader.isTextReplacement) {
				resourceTargetModelFieldData = resourceTargetModelField.dataTEXT;
			} else {
				resourceTargetModelFieldData = resourceTargetModelField.dataJSON;
			}

			// prevent too many loops on slave preparation
			if(!resourceData.fec) resourceData.fec = {}
			if(!resourceData.fec.refs) {
				resourceData.fec.refs = {}
				var userReferenceTS = storage.user.getReferenceTS();

				for(routeID in resourceData.data || {}){
					refRoute = resourceData.data[routeID] || {};

					// visibility check
					refRoute.visible = !!(
						(
							!refRoute.parentRouteID
							||
							(resourceData.fec.refs[refRoute.parentRouteID] || {}).visible
						)
						&& storage.user.hasAccessTo(refRoute.privilegeCode, refRoute.scope)
						&& storage.user.statusVisible(refRoute.status)
						&&
						(
							!refRoute.periodStart
							||
							refRoute.periodStart == null
							||
							userReferenceTS >= refRoute.periodStart
						)
						&&
						(
							!refRoute.periodEnd
							||
							refRoute.periodEnd == null
							||
							userReferenceTS <= refRoute.periodEnd
						)
					);

					resourceData.fec.refs[routeID] = refRoute;
				}
			}

			// prepare routes for text-replacement in html fields
			if(resourceLoader.isTextReplacement){
				var regex = new RegExp(/cmspage:\/\/([0-9]+)\$/, 'g');
				componentInstance.model[resourceLoader.target.fieldCode] = resourceTargetModelFieldData.replace(regex, function(match, elementID){
					var result = '#';
					route = resourceData.fec.refs[elementID * 1];
					if(route.visible){
						result = route.path || '#';
					}
					return result;
				});
			}
			// prepare routes for later use in templates
			else {
				for(routeIndex in resourceTargetModelFieldData || {}){
					assignedRoutes = resourceTargetModelFieldData[routeIndex];
					if(!assignedRoutes.hasSuccessfullyBeenPrepared){
						assignedRoutes.missingMainDBEntry = true;
						route = utils.simpleCopy(assignedRoutes);

						// prepare routeID dependent elements (e.g., there may be link builder elements in the future without any routeIDs which has to be prepared too.)
						if(assignedRoutes.routeID && (refRoute = resourceData.fec.refs[assignedRoutes.routeID])){
							route.resource = utils.simpleCopy(refRoute)

							// prepare route
							utils.routes.prepare(route, storage);

							// assign data to modelField
							route.hasSuccessfullyBeenPrepared = true;

							delete route.missingMainDBEntry;
						}
						// TODO: OTHER CASES

						resourceTargetModelFieldData[routeIndex] = route;
					}
				}
			}
		},

		/**
		 * prepare resource pickers data according to given resourceData param.
		 *
		 * @param modelField					object - reference to right modelField
		 * @param resourceTargetModelField 		object - reference to modelField where the data should be stored
		 * 										NOTE: may differ according to isPicked flag.
		 * @param resourceData					object - resourceData given by resourceAction (or serverside preloaded resourceData)
		 * @param storage						object - actual storage
		 * @param resourceLoader				object - reference on resourceLoader used for picking
		 */
		prepareRouteComponentPicker: function(modelField, resourceTargetModelField, resourceData, storage, resourceLoader){
			//////////////// VALID OPTIONS ///////////////////
			//// parentRouteID || routeID || route
			//// includeParentRoute (if parentRouteID)
			//// componentID || componentList
			//////////////////////////////////////////////////

			resourceLoader = resourceLoader || {};
			resourceTargetModelField = resourceTargetModelField || {};
			var options = [];
			var routeOption = {};
			var route, routeAttributes, routeID;
			var routeComponentAttributes;
			var routes = {};
			var routeComponents = null;
			var grantedRoutes = {};
			var routeParents = false;
			var routeComponentParents = false;
			var routeRegex = false;
			var target;
			var result = {};

			var fieldConfig = (modelField || {}).config || {};
			if(fieldConfig.routeID) 									fieldConfig.routeID = parseInt(fieldConfig.routeID);
			if(fieldConfig.parentRouteID) 								fieldConfig.parentRouteID = parseInt(fieldConfig.parentRouteID);
			if(fieldConfig.componentID) 								fieldConfig.componentID = parseInt(fieldConfig.componentID);
			if(utils.collectionSize(fieldConfig.componentList) < 1)		fieldConfig.componentList = false;
			if(fieldConfig.route) 										routeRegex = new RegExp('^' + fieldConfig.route + '.+');


			// sort resources by tree sort logic if necessary
			if(!fieldConfig.routeID) {
				utils.sortTreeResources(resourceData, 'parentRouteID', routeParents = {});
			}

			// collect id indexed list
			utils.forEach((resourceData || {}).data || [], function(data, dataIndex){
				if((data || {}).attributes){
					routes[data.attributes[data.primaryKey || 'id']] = dataIndex;
				}
			});

			// collect list of granted routeIDs according to the given restrictions
			utils.forEach(routeParents || routes, function(routeParentsPerLevel, routeID){
				route = resourceData.data[routes[routeID]] || {};
				routeAttributes = route.attributes || {};
				if(
					// picked routeID check
					(
						!fieldConfig.routeID
						||
						(
							routeID === fieldConfig.routeID
						)
					)
					&&
					// picked route check (route may be parent
					(
						!routeRegex
						||
						(
							(
								fieldConfig.includeParentRoute
								&&
								routeAttributes.path === fieldConfig.route
							)
							||
							String(routeAttributes.path).match(routeRegex) !== null
						)
					)
					&&
					// parentRouteID check
					(
						!fieldConfig.parentRouteID
						||
						(
							fieldConfig.includeParentRoute
							&&
							routeID === fieldConfig.parentRouteID
						)
						||
						(
							utils.isCollection(routeParentsPerLevel) // may be dataIndex of routes
							&&
							utils.indexOf(routeParentsPerLevel, fieldConfig.parentRouteID) > -1
						)
					)
				){
					grantedRoutes[routeID] = true;
				}
			});

			// collection granted options
			utils.forEach((resourceData || {}).data || [], function(data, dataIndex){
				if((routeAttributes = (data || {}).attributes) && grantedRoutes[(routeID = routeAttributes[(data || {}).primaryKey || 'id'])]){
					routeOption = {
						routeID: 	routeID,
						path: 		routeAttributes.path,
						langCode: 	routeAttributes.langCode,
						components: []
					}

					routeComponents = (data.children || {}).rtCps || {};
					if(utils.collectionSize(routeComponents.data) > 0){
						utils.sortTreeResources(routeComponents, 'parentRouteComponentID', routeComponentParents = {});

						utils.forEach(routeComponents.data, function(routeComponent, dataIndex){
							if(
								(routeComponentAttributes = (routeComponent || {}).attributes)
								&&
								// check componentID
								(
									!fieldConfig.componentID
									||
									routeComponentAttributes.componentID == fieldConfig.componentID
								)
								&&
								// check list of componentIDs
								(
									!fieldConfig.componentList
									||
									utils.indexOf(fieldConfig.componentList, routeComponentAttributes.componentID) > -1
								)
							){
								if(resourceTargetModelField.data == (routeID + '_' + routeComponentAttributes[routeComponent.primaryKey || 'id'])){
									result.route = routeAttributes;
									result.routeComponent = routeComponentAttributes;
								}

								routeOption.components.push(routeComponentAttributes);
							}
						});
					}

					if(resourceTargetModelField.data == routeID){
						result.route = routeAttributes;
					}

					options.push(routeOption);
				}
			});

			// set options
			if(resourceLoader.isPicked){
				target = resourceTargetModelField;
			} else {
				if(!resourceTargetModelField['route-component-picker-data']) resourceTargetModelField['route-component-picker-data'] = {};
				target = resourceTargetModelField['route-component-picker-data'];
			}
			target.options = options;


			// estimate minFuturePeriodChangeAt timestamp
			var userReferenceTS = storage.user.getReferenceTS();
			if(((result.route || {}).periodStart && result.route.periodStart > userReferenceTS && (!storage.request.minFuturePeriodChangeAt || storage.request.minFuturePeriodChangeAt > result.route.periodStart))){
				storage.request.minFuturePeriodChangeAt = result.route.periodStart;
			}
			if(((result.route || {}).periodEnd && result.route.periodEnd > userReferenceTS && (!storage.request.minFuturePeriodChangeAt || storage.request.minFuturePeriodChangeAt > result.route.periodEnd))){
				storage.request.minFuturePeriodChangeAt = result.route.periodEnd;
			}
			if(((result.routeComponent || {}).periodStart && result.routeComponent.periodStart > userReferenceTS && (!storage.request.minFuturePeriodChangeAt || storage.request.minFuturePeriodChangeAt > result.routeComponent.periodStart))){
				storage.request.minFuturePeriodChangeAt = result.routeComponent.periodStart;
			}
			if(((result.routeComponent || {}).periodEnd && result.routeComponent.periodEnd > userReferenceTS && (!storage.request.minFuturePeriodChangeAt || storage.request.minFuturePeriodChangeAt > result.routeComponent.periodEnd))){
				storage.request.minFuturePeriodChangeAt = result.routeComponent.periodEnd;
			}

			if(
				(
					!result.route
					||
					// status check
					!!(
						(
							storage.user
							&&
							utils.isFunction(storage.user.statusVisible)
							&&
							storage.user.statusVisible(result.route.status)
						)
						||
						(
							(
								utils.isEmpty(result.route.status)
								||
								result.route.status === 'active'
								||
								result.route.status === 'preview & active'
								||
								result.route.status === 'invisible'
							)
						)
					)
					&&
					// period check
					(
						(
							!result.route.periodStart
							||
							userReferenceTS >= result.route.periodStart
						)
						&&
						(
							!result.route.periodEnd
							||
							userReferenceTS <= result.route.periodEnd
						)
					)
				)
				&&
				(
					!result.routeComponent
					||
					// status check
					!!(
						(
							storage.user
							&&
							utils.isFunction(storage.user.statusVisible)
							&&
							storage.user.statusVisible(result.routeComponent.status)
						)
						||
						(
							(
								utils.isEmpty(result.routeComponent.status)
								||
								result.routeComponent.status === 'active'
								||
								result.routeComponent.status === 'preview & active'
								||
								result.routeComponent.status === 'invisible'
							)
						)
					)
					&&
					// period check
					(
						(
							!result.routeComponent.periodStart
							||
							userReferenceTS >= result.routeComponent.periodStart
						)
						&&
						(
							!result.routeComponent.periodEnd
							||
							userReferenceTS <= result.routeComponent.periodEnd
						)
					)
				)
			){
				target.result = result;
			}
		},

		/**
		 * prepare resource pickers data according to given resourceData param.
		 *
		 * @param modelField					object - reference to right modelField
		 * @param resourceTargetModelField 		object - reference to modelField where the data should be stored
		 * 										NOTE: may differ according to isPicked flag.
		 * @param resourceData					object - resourceData given by resourceAction (or serverside preloaded resourceData)
		 * @param storage						object - actual storage
		 * @param resourceLoader				object - reference on resourceLoader used for picking
		 */
		prepareCategoryPicker: function(modelField, resourceTargetModelField, resourceData, storage, resourceLoader){
			//////////////// VALID OPTIONS ///////////////////
			//// categoryID || categoryCode
			//// filterByServiceAvailableLangCodes
			//////////////////////////////////////////////////

			resourceLoader = resourceLoader || {};
			resourceTargetModelField = resourceTargetModelField || {};
			var categoryPickerData = {};
			var categoryAttributes = {};
			var categoryData = {};
			var categoryDataOption = {};
			var categoryDataAttributes = {};
			var categoryDataTrlAttributes = {};
			const {available: availableLangCodes} = utils.language.getConfig(storage)
			var value;
			var result = {};
			var preparedFields = {};
			var matches;
			var target;

			var fieldConfig = (modelField || {}).config || {};
			if(fieldConfig.categoryID) {
				fieldConfig.categoryID = fieldConfig.categoryID * 1;
			}

			if(!fieldConfig.categoryID && !fieldConfig.categoryCode){
				console.log('MISSING_IDENTIFIER_FOR_CATEGORY_PICKER')
			}

			// prepare fields which are needed within the value params
			if((matches = String(fieldConfig.value || '').match(/{[\w_\-\d]+}/g)) && matches !== null){
				for(var i in matches){
					preparedFields[matches[i].replace(/[{}]/g, '')] = new RegExp(matches[i], 'g');
				}
			}

			utils.forEach(resourceData.data || [], function(category, dataIndex){
				if(
					(categoryAttributes = (category || {}).attributes)
					&&
					// check categoryID
					(
						!fieldConfig.categoryID
						||
						categoryAttributes[category.primaryKey || 'id'] === fieldConfig.categoryID
					)
					&&
					// check categoryCode
					(
						!fieldConfig.categoryCode
						||
						categoryAttributes.code === fieldConfig.categoryCode
					)
				){
					categoryPickerData = {
						categoryID:         categoryAttributes[category.primaryKey || 'id'],
						parentCategoryID:   categoryAttributes.parentCategoryID,
						code:               categoryAttributes.code,
						options:           []
					};

					categoryData = (category.children || {}).catData || {};
					utils.sortTreeResources(categoryData, 'parentCategoryDataID');

					utils.forEach(categoryData.data || [], function(categoryData, dataIndex){
						categoryDataAttributes = (categoryData || {}).attributes || {};
						if(
							!fieldConfig.filterByServiceAvailableLangCodes
							||
							availableLangCodes[categoryDataAttributes.value] !== undefined
							||
							!categoryDataAttributes.value
						){
							// define by values for value and name
							if(fieldConfig.value) 							value = fieldConfig.value + '';
							else if(categoryDataAttributes.value === null)  value = '';
							else                  							value = categoryDataAttributes.value + '';

							// replace all fields within the strings
							utils.forEach(preparedFields, function(fieldRegExp, fieldKey){
								value = value.replace(fieldRegExp, categoryDataAttributes[fieldKey] || '');
							});

							categoryDataOption = {
								categoryDataID: 	categoryDataAttributes[categoryData.primaryKey || 'id'],
								categoryID: 		categoryDataAttributes.categoryID,
								priority: 			categoryDataAttributes.priority,
								color: 				categoryDataAttributes.color,
								config: 			categoryDataAttributes.config,
								value: 				value,
								defaultSelected: 	categoryDataAttributes.defaultSelected,
								lang: 				{}
							};

							utils.forEach(((categoryData.children || {}).cms_categoriesDataTrl || {}).data || [], function(categoryDataTrl, dataIndex){
								categoryDataTrlAttributes = (categoryDataTrl || {}).attributes || {};
								categoryDataOption.lang[categoryDataTrlAttributes.langCode] = {
									categoryDataTrlID: 	categoryDataTrlAttributes[categoryDataTrl.primaryKey || 'id'],
									categoryDataID: 	categoryDataTrlAttributes.categoryDataID,
									name: 				categoryDataTrlAttributes.name,
									description: 		categoryDataTrlAttributes.description,
									info: 				categoryDataTrlAttributes.info
								};
							});

							categoryPickerData.options.push(categoryDataOption);

							// identify selected result
							if(resourceTargetModelField.data == categoryDataOption.value){
								result.category = utils.replace(categoryPickerData, { options: undefined });
								result.categoryData = categoryDataOption;
							}
						}
					});

					return false;
				}
			});

			// set options
			if(resourceLoader.isPicked){
				utils.refReplace(resourceTargetModelField, categoryPickerData)
				target = resourceTargetModelField;
			} else {
				resourceTargetModelField['category-picker-data'] = categoryPickerData;
				target = resourceTargetModelField['category-picker-data'];
			}

			// set result according to given data and options
			if(result.category && result.categoryData) target.result = result;
		},

		/**
		 * prepare mediaImage data according to given resourceData param. (tags and mediaTrl, ...)
		 *
		 * @param modelField					object - reference to right modelField
		 * @param resourceTargetModelField 		object - reference to modelField where the data should be stored
		 * 										NOTE: may differ according to isPicked flag.
		 * @param resourceData					object - resourceData given by resourceAction (or serverside preloaded resourceData)
		 * @param storage						object - actual storage
		 * @param resourceLoader				object - reference on resourceLoader used for picking
		 */
		prepareMediaImage: function(modelField, resourceTargetModelField, resourceData, storage, resourceLoader){
			resourceTargetModelField = resourceTargetModelField || {};
			resourceData = resourceData || {};
			resourceLoader = resourceLoader || {};
			var mediaIndex;
			var assignedMedia, m, refMedia, media, mediaID, rendered;
			var mr, amr;
			var resourceTargetModelFieldData;

			if(resourceLoader.isPicked){
				resourceTargetModelFieldData = resourceTargetModelField;
			} else {
				resourceTargetModelFieldData = resourceTargetModelField.dataJSON;
			}

			// prevent too many loops on slave preparation
			if(!resourceData.fec) resourceData.fec = {}
			if(!resourceData.fec.refs) {
				resourceData.fec.refs = {}
				for(m in resourceData.data || []){
					refMedia = resourceData.data[m] || {};
					mediaID = (refMedia.attributes || {})[refMedia.primaryKey || 'id'];
					if(mediaID) {
						resourceData.fec.refs[mediaID] = refMedia;
					}
				}
			}

			for(mediaIndex in resourceTargetModelFieldData || {}){
				assignedMedia = resourceTargetModelFieldData[mediaIndex];

				if(!assignedMedia.hasSuccessfullyBeenPrepared){
					assignedMedia.missingMainDBEntry = true;

					if(assignedMedia !== null && assignedMedia.mediaID && (refMedia = resourceData.fec.refs[assignedMedia.mediaID])){
						delete assignedMedia.missingMainDBEntry;

						const usedPermissions = {
							read: 	utils.permissions.hasAccessTo(storage, (refMedia.attributes || {}).permissions, 'read', resourceLoader.scope, 'cms_media'),
							write: 	utils.permissions.hasAccessTo(storage, (refMedia.attributes || {}).permissions, 'write', resourceLoader.scope, 'cms_media'),
						}

						if(usedPermissions.read === false) {
							assignedMedia.permissions = utils.replace((refMedia.attributes || {}).permissions, { owner: undefined })
							assignedMedia.usedPermissions = usedPermissions
						} else {
							media = utils.simpleCopy(refMedia)
							media.usedPermissions = usedPermissions

							// media defaults
							if(!media.children) 						media.children = {};
							if(!media.children.cms_assignedMedia) 		media.children.cms_assignedMedia = {};
							if(!media.children.cms_mediaRendered) 		media.children.cms_mediaRendered = {};
							if(!media.children.cms_entities_categories) media.children.cms_entities_categories = {};

							// media index
							media.attributes.index = mediaIndex;

							// assigned media data
							media.children.cms_assignedMedia = {
								data: assignedMedia.data
							};

							// collect assigned rendered media
							rendered = [];
							for(amr in assignedMedia.rendered || []){
								for(mr in (((media || {}).children || {}).cms_mediaRendered || {}).data || []){
									if(assignedMedia.rendered[amr].mediaRenderedID === (media.children.cms_mediaRendered.data[mr].attributes || {}).mediaRenderedID){
										rendered[amr] = media.children.cms_mediaRendered.data[mr];
										break;
									}
								}
							}
							media.children.cms_mediaRendered.data = rendered;

							// prepare media
							utils.media.image.prepare(media, storage, resourceLoader.requestedService, resourceLoader.scope);

							// assign data to modelField
							media.hasSuccessfullyBeenPrepared = true;

							// respect assignment pause
							if(assignedMedia.pause) media.pause = true

							resourceTargetModelFieldData[mediaIndex] = media;
						}
					}
				}
			}
		},

		/**
		 * prepare mediaFile data according to given resourceData param. (tags and mediaTrl, ...)
		 *
		 * @param modelField					object - reference to right modelField
		 * @param resourceTargetModelField 		object - reference to modelField where the data should be stored
		 * 										NOTE: may differ according to isPicked flag.
		 * @param resourceData					object - resourceData given by resourceAction (or serverside preloaded resourceData)
		 * @param storage						object - actual storage
		 * @param resourceLoader				object - reference on resourceLoader used for picking
		 */
		prepareMediaFile: function(modelField, resourceTargetModelField, resourceData, storage, resourceLoader){
			resourceTargetModelField = resourceTargetModelField || {};
			resourceData = resourceData || {};
			resourceLoader = resourceLoader || {};
			var mediaIndex;
			var assignedMedia, m, refMedia, media, mediaID;
			var resourceTargetModelFieldData;

			if(resourceLoader.isPicked){
				resourceTargetModelFieldData = resourceTargetModelField;
			} else {
				resourceTargetModelFieldData = resourceTargetModelField.dataJSON;
			}

			// prevent too many loops on slave preparation
			if(!resourceData.fec) resourceData.fec = {}
			if(!resourceData.fec.refs) {
				resourceData.fec.refs = {};
				for(m in resourceData.data || []){
					refMedia = resourceData.data[m] || {};
					mediaID = (refMedia.attributes || {})[refMedia.primaryKey || 'id'];
					if(mediaID) resourceData.fec.refs[mediaID] = refMedia;
				}
			}

			for(mediaIndex in resourceTargetModelFieldData || {}){
				assignedMedia = resourceTargetModelFieldData[mediaIndex];

				if(!assignedMedia.hasSuccessfullyBeenPrepared){
					assignedMedia.missingMainDBEntry = true;

					if(assignedMedia !== null && assignedMedia.mediaID && (refMedia = resourceData.fec.refs[assignedMedia.mediaID])){
						delete assignedMedia.missingMainDBEntry;

						const usedPermissions = {
							read: 	utils.permissions.hasAccessTo(storage, (refMedia.attributes || {}).permissions, 'read', resourceLoader.scope, 'cms_media'),
							write: 	utils.permissions.hasAccessTo(storage, (refMedia.attributes || {}).permissions, 'write', resourceLoader.scope, 'cms_media'),
						}

						if(usedPermissions.read === false) {
							assignedMedia.permissions = utils.replace((refMedia.attributes || {}).permissions, { owner: undefined })
							assignedMedia.usedPermissions = usedPermissions
						} else {
							media = utils.simpleCopy(refMedia)
							media.usedPermissions = usedPermissions

							// media defaults
							if(!media.children) 						media.children = {};
							if(!media.children.cms_entities_categories) media.children.cms_entities_categories = {};

							// media index
							media.attributes.index = mediaIndex;

							// prepare media
							utils.media.file.prepare(media, storage, resourceLoader.requestedService, resourceLoader.scope);

							media.hasSuccessfullyBeenPrepared = true

							// assign data to modelField
							resourceTargetModelFieldData[mediaIndex] = media;
						}
					}
				}
			}
		}
	},

	permissions: {

		/**
		 * mirror function of postgres permissions_v1 extension used for "permissions"-fields.
		 * in extension to the basic functionality the mimicOwner privilege will be checked for admin privileges.
		 *
		 * @param storage			actual storage
		 * @param permissions		permissions - @see postgres permissions type
		 * @param accessType		string - read, write
		 * @param userID			number - userID - default will be set by user within given storage
		 * @param isServiceUser		boolean - is this user a serviceUser? - default will be set by user within given storage
		 * @returns boolean || null
		 */
		hasAccessTo(storage, permissions = null, accessType = 'read', scope = null, model = null, userID = undefined, isServiceUser = undefined){
			if(!permissions) return true; // no permissions => public access
			if(accessType !== 'read' && accessType !== 'write') return null; // invalid access type => access cannot be determined

			// admin access
			if(scope && model && (storage || {}).user && storage.user.hasAccessTo(`${model}:permissions:mimicOwner`, scope)){
				return true
			}

			const userData = (storage.user || {}).data
			if(userData){
				if(userID === undefined) 		userID = userData.userID;
				if(isServiceUser === undefined) isServiceUser = !!userData.serviceUserID;
			}

			if(!userID) return !!((permissions || {}).public || {})[accessType]; // public access
			if(((permissions || {}).owner || {}).userID === userID && ((permissions || {}).owner || {}).isServiceUser === isServiceUser) return true; // owner access
			return !!((permissions || {}).auth || {})[accessType]; // authenticated non-owner access
		},

		/**
		 * returns owner based on given storage
		 *
		 * @param storage		actual storage
		 * @returns {{userID: (*|null), isServiceUser: boolean}}
		 */
		getOwner(storage){
			const user = ((storage || {}).user || {}).data || {}
			return {
				userID: 		user.userID || null,
				isServiceUser: 	!!user.serviceUserID,
			}
		},

		/**
		 * since postgres composite types default every boolean field with false this default is used for when writing a permissions field.
		 *
		 * @param storage
		 * @returns {{auth: {read: boolean, write: boolean}, public: {read: boolean, write: boolean}}}
		 */
		getDefault(storage){
			return {
				auth: {
					read: true,
					write: true,
				},
				public: {
					read: true,
					write: false, // this is merely defined for clarity purposes, since no public media uploads are granted at the moment.
				},
			}
		},
	},


	///////////////////////////////////////////////
	///// MODEL HELPERS
	///////////////////////////////////////////////

	/**
	 * this function is useful if a parent-component has to handle mutliple standard buttons.
	 *
	 * @param   event                           object - actual dom-click-event
	 * @param   actionBossComponentClass        string - closest potential action-boss-component
	 * @param   additionalData                  object - additionalData to pass to the actions or function-calls
	 * @param   buttonData						object - in case of manual triggers without an event this flag can contain all necessary information about the buttons' definition
	 * @param   [isOptional]					boolean - default: false - prevent console.errors on optional button actions
	 * @return  Promise
	 */
	performButtonAction: function(event, actionBossComponentClass, additionalData, buttonData, isOptional, actionBossComponent){
		if(!event && !buttonData) return utils.promise.reject('no event found');

		if(event){
			buttonData = {};

			var target = event.originalEvent ? event.originalEvent.target : event.target;
			buttonData.type = target.nodeName.toLowerCase();

			// take icons parents automatically
			if(buttonData.type === 'i'){
				target = utils.$(target).parent()[0];
				buttonData.type = target.nodeName.toLowerCase();
			}

			buttonData.fieldType			= target.dataset.fieldType;
			buttonData.context      		= target.dataset.buttonContext;
			buttonData.mode         		= target.dataset.buttonMode;
			buttonData.componentInCharge 	= actionBossComponent || event.data.component;
		}
		else if(buttonData){
			buttonData.type = 'button';
			if(!buttonData.fieldType || !buttonData.componentInCharge) return utils.promise.reject('invalid buttonData found');
		}

		var promise;
		var resolveData = {
			actionPerformed:    false,
			fieldType:          buttonData.fieldType,
			additionalData:     additionalData
		};

		switch (buttonData.type) {
			case 'a':
			case 'button':
				buttonData.potentialActionKey = buttonData.fieldType;
				if(buttonData.context) buttonData.potentialActionKey += '_' + buttonData.context;

				var actionBossComponent;
				buttonData.componentInCharge.closest(buttonData.componentInCharge.config.actionBossComponentClass || actionBossComponentClass, function(parentComponent){
					actionBossComponent = parentComponent;
				});

				resolveData.buttonContext 			= buttonData.context;
				resolveData.buttonMode 				= buttonData.mode;
				resolveData.potentialActionKey 		= buttonData.potentialActionKey;
				resolveData.actionBossComponent 	= actionBossComponent;

				// this action form should handle the operation by itself.
				if(utils.isFunction(buttonData.componentInCharge[buttonData.fieldType])){
					promise = buttonData.componentInCharge[buttonData.fieldType](buttonData.potentialActionKey, buttonData.context, buttonData.mode, actionBossComponent, additionalData);
				}
				// default actions of this action form can be performed without operation function too
				else if(buttonData.componentInCharge.actions[buttonData.potentialActionKey] != undefined){
					promise = buttonData.componentInCharge.performAction(buttonData.componentInCharge.prepareAction(buttonData.potentialActionKey, undefined, { additionalData: additionalData }));
				}
				// actionBossComponent should handle the operation
				else if(actionBossComponent != undefined && utils.isFunction(actionBossComponent[buttonData.fieldType])){
					promise = actionBossComponent[buttonData.fieldType](buttonData.potentialActionKey, buttonData.context, buttonData.mode, actionBossComponent, additionalData);
				}
				// default actions of actionBossComponent can be performed without operation function too
				else if(actionBossComponent != undefined && actionBossComponent.actions[buttonData.potentialActionKey] != undefined){
					promise = actionBossComponent.performAction(actionBossComponent.prepareAction(buttonData.potentialActionKey, undefined, { additionalData: additionalData }));
				}
				else if (!isOptional) {
					console.error('button action not found: ' + buttonData.potentialActionKey);
				}
				break;
		}

		if(promise){
			if(event){
				event.preventDefault()
				event.stopImmediatePropagation()
			}

			if(utils.isFunction(promise.then)){
				resolveData.actionPerformed = true;
				return promise.then(function(context){
					resolveData.response = (context || {}).response;
					return utils.promise.resolve(resolveData);
				});
			} else {
				resolveData.response = promise;
			}
		}

		return utils.promise.resolve(resolveData);
	},

	/**
	 * this function is used to return the right attributeKey according to the given dataType of an atom.
	 *
	 * @param   dataType        string - atom dataType
	 * @returns                 string - key according to dataType
	 */
	getDataValueKey: function(dataType){
		switch(dataType){
			// ['text','integer','float','date','time','datetime','html','media-file','media-image','boolean','route-picker','db-picker','table'],
			case 'uuid':
			case 'template-picker':
			case 'html':
			case 'text':            return 'dataTEXT';
			case 'boolean':
			case 'integer':         return 'dataINT';
			case 'float':           return 'dataFLOAT';
			case 'time':			return 'dataTIME';
			case 'datetime':
			case 'date':            return 'dataDATE';
			case 'json':
			case 'select':
			case 'route-picker':
			case 'resource-picker':
			case 'tag-picker':
			case 'media-image':
			case 'media-file':
			default:                return 'dataJSON';
		}
	},

	/**
	 * prepare an object indicating which fieldCodes have changed within an protocolAction
	 * and determine if therefor the corresponding field should be visible or not
	 * in case a protocolAction is shown (as a form).
	 *
	 * @param protocolActionFieldContainer
	 * @param modelFields
	 * @param mapFieldsViaTemplateAtomIDs
	 * @returns {
	 *     <string fieldCode>: <boolean visiblity>
	 * }
	 */
	getProtocolActionFieldVisibility: function(protocolActionFieldContainer = {}, modelFields = {}, mapFieldsViaTemplateAtomIDs = false){
		protocolActionFieldContainer = protocolActionFieldContainer || {}

		let protocolActionFields = protocolActionFieldContainer.attributes || {}
		if(mapFieldsViaTemplateAtomIDs){
			protocolActionFields = protocolActionFieldContainer.templateAtoms || {}
		}
		modelFields = modelFields || {}

		const visibleFieldCodes = {}
		const fieldCodeToTemplateAtomIDMapping = {}
		const templateAtomIDToFieldCodeMapping = {}

		if(mapFieldsViaTemplateAtomIDs) {
			utils.forEach(modelFields, function(field) {
				fieldCodeToTemplateAtomIDMapping[field.fieldCode] = field.templateAtomID
				templateAtomIDToFieldCodeMapping[field.templateAtomID] = field.fieldCode
			})

			for(const templateAtomID in protocolActionFields){
				visibleFieldCodes[templateAtomIDToFieldCodeMapping[templateAtomID]] = true
			}
		} else {
			for(const fieldCode in protocolActionFields){
				visibleFieldCodes[fieldCode] = true
			}
		}

		let fieldCodes, relationConfig
		utils.forEach(modelFields, function(field) {
			if (field.fieldCode) {
				if(utils.collectionSize((fieldCodes = ((field.config || {}).separatedFieldCodes))) > 0){
					utils.forEach(fieldCodes, function(foreignFieldCode, foreignFieldCodeAlias){
						// e.g., grant routeLimitationsByRouteTags via routeLimitations.byRouteTags of routeLimitations field
						if(visibleFieldCodes[field.fieldCode]){
							visibleFieldCodes[foreignFieldCode] = true
						}
						// e.g., grant period via periodStart of period field
						else if(visibleFieldCodes[foreignFieldCode]){
							visibleFieldCodes[field.fieldCode] = true
							return false
						}
					})
				}

				if(!mapFieldsViaTemplateAtomIDs && (relationConfig = ((field.config || {}).relationConfig)) && relationConfig.subFormAlias && protocolActionFieldContainer[relationConfig.subFormAlias] !== undefined){
					visibleFieldCodes[field.fieldCode] = true
				}
			}
		})

		return visibleFieldCodes
	},

	/**
	 * prepare categories and write the conclusion to the given refCategoriesOptions reference.
	 * NOTE: this function may be used for different data structures:
	 * 		1. cms_categories->catData->...
	 * 		2. cms_entities_categories->catData->...
	 * 		3. categories->catData->... @see server/resourceTemplates/index.js[tagPicker]
	 *
	 * @param refCategoriesOptions		object - reference to categoriesOptionsTargetVariable
	 * @param categories				array - resourceData categories to prepare
	 * @param storage       			object - actual storage
	 * @param [inheritedCategories]		object - inherited categories
	 * @param [actualScope]				string - actual components' scope
	 * @param [preventSortIndex=false]	boolean - should the elements index be defined by elements' id only?
	 */
	prepareCategories: function(refCategoriesOptions, categories, storage, inheritedCategories, actualScope, preventSortIndex){
		refCategoriesOptions = refCategoriesOptions || {}
		inheritedCategories = inheritedCategories || {}

		const langCode = (storage || {}).langCode || 'de-at'
		let categoryAttributes, categoryDataAttributes, categoryID, categoryDataID, categoryIndex, categoryDataIndex, categoriesDataOptions
		let categoriesData, categoryDataParents, fullCategoryDataParents
		let categoriesDataName, categoryDataTrls, categoriesName, categoryTrls
		let tagKey, categoryTrlAttributes, categoryDataTrlAttributes
		let categoryDataIndexChain, categoryDataIndexChains
		let subCategory, tagScope, tagScopes, tagScopeCode
		const turnedOffTagCategoryManagement = storage.user ? storage.user.hasAccessTo('usage:turnedOffTagCategoryManagement', actualScope) : false

		utils.forEach(utils.isArray(categories) ? categories : [categories], function(category){

			if(category !== null){
				categoryAttributes = category.attributes || {}
				categoryID = categoryAttributes.categoryID || null
				if(preventSortIndex === true) 	categoryIndex = categoryID;
				else 							categoryIndex = (categoryAttributes.sort || 0) + '_' + categoryID;

				categoriesName = ''
				categoryTrls = category.trls || ((category.children || {}).cms_categoriesTrl || {}).data || []
				categoryTrlAttributes = {}
				if(categoryTrlAttributes[langCode]){
					categoryTrlAttributes = categoryTrlAttributes[langCode]
					categoriesName = categoryTrlAttributes.name
				} else {
					utils.forEach(categoryTrlAttributes, trl => {
						if ((trl.attributes || {}).langCode === langCode) {
							categoryTrlAttributes = trl.attributes
							categoriesName = categoryTrlAttributes.name
							return false
						}
					})
				}

				// just if this function will be used to prepare "cms_entities_categories"
				// this is the way to prepare the real category and tagScope attributes.
				subCategory = ((category.children || {}).cms_categories || {}).data || {}
				if(!categoriesName) categoriesName = categoryAttributes.code || (subCategory.attributes || {}).code || 'NO-CATEGORY-NAME-FOUND';

				if(!refCategoriesOptions[categoryIndex]) {
					refCategoriesOptions[categoryIndex] = {
						id: 								categoryAttributes[category.primaryKey || 0] || null,
						name: 								categoriesName,
						turnedOff: 							false,
						turnedOn: 							false,
						turnedOffByInheritance: 			false,
						turnedOffTagCategoryManagement: 	turnedOffTagCategoryManagement,
						children: 							{},
						resources: 							{
							...categoryAttributes,
							trl: categoryTrlAttributes
						},
						tagScopes: 							{}
					}
				}
				refCategoriesOptions[categoryIndex].turnedOff =
					refCategoriesOptions[categoryIndex].turnedOff ||
					(category.primaryKey === 'entityCategoryID' && categoryAttributes.categoryDataID === null ? (categoryAttributes.enabled !== true) : false)
				;
				refCategoriesOptions[categoryIndex].turnedOn =
					refCategoriesOptions[categoryIndex].turnedOn ||
					(category.primaryKey === 'entityCategoryID' && categoryAttributes.categoryDataID === null ? (categoryAttributes.enabled === true) : false)
				;
				refCategoriesOptions[categoryIndex].turnedOffByInheritance =
					refCategoriesOptions[categoryIndex].turnedOffByInheritance ||
					inheritedCategories[refCategoriesOptions[categoryIndex].resources.categoryID || 0] === false // undefined || false || true
				;

				// just if this function will be used to prepare "cms_entities_categories"
				// this is the way to prepare the real category and tagScope attributes.
				tagScope = {}
				tagScopes = {}
				tagScopeCode = ''
				utils.forEach(((subCategory.children || {}).cms_tagScopes_categories || {}).data || [], function(tagScopeCategory){
					if(tagScopeCategory.attributes && (tagScope = (((tagScopeCategory.children || {}).cms_tagScopes || {}).data || {}).attributes || {}) && (tagScopeCode = tagScope.code)){
						if(!refCategoriesOptions[categoryIndex].tagScopes[tagScopeCode]){
							refCategoriesOptions[categoryIndex].tagScopes[tagScopeCode] = {
								resources: tagScope
							}
						}
					}
				})

				// prepare categoriesData
				categoriesDataOptions = []
				categoriesData = category.catData || ((category.children || {}).catData || {}).data || []

				categoryDataParents = {}
				categoryDataIndexChains = {}
				fullCategoryDataParents = {}
				utils.prepareListOfParents((utils.isArray(categoriesData) ? categoriesData : [categoriesData]), 'parentCategoryDataID', categoryDataParents, fullCategoryDataParents)

				utils.forEach((utils.isArray(categoriesData) ? categoriesData : [categoriesData]), function(categoryData){
					categoryDataAttributes = categoryData.attributes || {}
					categoryDataID = categoryDataAttributes[categoryData.primaryKey || 0] || null
					if(preventSortIndex === true) 	categoryDataIndex = categoryDataID;
					else 							categoryDataIndex = (categoryDataAttributes.sort || 0) + '_' + categoryDataID;

					tagKey = ''
					if(categoryID && categoryDataID){
						tagKey = `${categoryID}_${categoryDataID}`
					}

					categoriesDataName = ''
					categoryDataTrls = categoryData.trls || ((categoryData.children || {}).cms_categoriesDataTrl || {}).data || []
					categoryDataTrlAttributes = {}
					if(categoryDataTrls[langCode]){
						categoryDataTrlAttributes = categoryDataTrls[langCode]
						categoriesDataName = categoryDataTrlAttributes.name
					} else {
						utils.forEach(categoryDataTrls, trl => {
							if ((trl.attributes || {}).langCode === langCode) {
								categoryDataTrlAttributes = trl.attributes
								categoriesDataName = categoryDataTrlAttributes.name
								return false;
							}
						})
					}
					if(!categoriesDataName){
						categoriesDataName = categoryDataAttributes.value || 'NO-CATEGORY-DATA-NAME-FOUND'
					}

					if(!refCategoriesOptions[categoryIndex].children[categoryDataIndex]){

						if (categoryDataAttributes.parentCategoryDataID > 0 && categoryDataIndexChains[categoryDataAttributes.parentCategoryDataID]){
							categoryDataIndexChain = utils.copy(categoryDataIndexChains[categoryDataAttributes.parentCategoryDataID]);
						} else {
							categoryDataIndexChain = {}
						}
						categoryDataIndexChains[categoryDataID] = categoryDataIndexChain
						categoryDataIndexChains[categoryDataID][utils.collectionSize(categoryDataIndexChains[categoryDataID])] = categoryDataIndex

						try {
							refCategoriesOptions[categoryIndex].children[categoryDataIndex] = {
								id: 			categoryDataID,
								tagKey,
								name: 			categoriesDataName,
								names: 			((refCategoriesOptions[categoryIndex].children[categoryDataIndexChains[categoryDataID][Object.keys(categoryDataIndexChains[categoryDataID]).length - 2] || 'NO_PARENT_AVAILABLE'] || {}).names || []).concat([categoriesDataName]),
								level: 			utils.collectionSize(categoryDataParents[categoryDataID] || {}),
								indexChain:  	categoryDataIndexChains[categoryDataID],
								children: 		(fullCategoryDataParents[categoryDataID] || {}).children || {},
								nrOfChildren: 	utils.collectionSize((fullCategoryDataParents[categoryDataID] || {}).children || {}),
								resources: 		{
									...categoryDataAttributes,
									trl: categoryDataTrlAttributes,
								},
							}
						} catch (error){
							console.log()
						}
					}
				})
			}
		})
	},

	/**
	 * get a list of entities' categories and their inheritance values.
	 *
	 * @param resources			object - resources (e.g., routes) which should be the entities
	 * @param tagResources		object - tagResources (cms_entities_categories)
	 * @param parentIDKey		String - parentIDKey name (e.g., "parentRouteID")
	 * @param [refParents]		object - 	if this flag is given the list of level ordered parents of the resources' entities
	 * 									will be written to this var-reference.
	 * 									NOTE: the level ordered list is starting with { zero: zero, ... } which means <zero level>: <zero routeID of virtual root-leaf>
	 * @returns object - categoryInheritanceValues
	 */
	prepareTagCategoryInheritanceList: function(resources, tagResources, parentIDKey, refParents){
		// prepare list of parents level ordered (root to leaf) for each route if necessary
		var parents = {};
		if(refParents) parents = refParents
		utils.prepareListOfParents((resources || {}).data || [], parentIDKey || 'parentRouteID', parents);
		var categories = {};
		var inheritedCategories = {};
		var tagAttributes;

		// prepare list of categories' enabled state for each route and category
		utils.forEach((tagResources || {}).data || [], function(tag){
			tagAttributes = tag.attributes || {};
			if(tagAttributes.categoryDataID === null && tagAttributes.entityType === 'routes'){
				if(!categories[tagAttributes.entityID]) categories[tagAttributes.entityID] = {};
				categories[tagAttributes.entityID][tagAttributes.categoryID] = tagAttributes.enabled === true;
			}
		});

		// prepare inherited categories' enabled values for all routes according to their parents
		utils.forEach(parents, function(parent, id){
			inheritedCategories[id] = {};
			utils.forEach(parent, function(parentID, level){
				utils.forEach(categories[parentID] || {}, function(enabled, categoryID){
					inheritedCategories[id][categoryID] = enabled
				});
			});
		});

		return inheritedCategories;
	},

	/**
	 * returns a list of parents within a resource-structure given by key and parentKey (e.g., routeID and parentRouteID).
	 * NOTE: the key will be estimated as the primaryKey.
	 *
	 * @param resourceData		object - resourceData of entities
	 * @param parentIDKey		String - parentIDKey name (e.g., "parentRouteID")
	 * @param [refList]			object - 	if this flag is given the list of level ordered parents of the resources' entities
	 * 									will be written to this var-reference.
	 * 									NOTE: the level ordered list is starting with { zero: zero, ... } which means <zero level>: <zero routeID of virtual root-leaf>
	 * @param [refOriginalList]	object - 	if this flag is given the original list including parents, children, levels, levelDiffs will be stored within this parameter.
	 */
	prepareListOfParents: function(resourceData, parentIDKey, refList, refOriginalList){
		parentIDKey = parentIDKey || 'parentRouteID'

		let list = {}
		let cleanList = {}
		if(refOriginalList){
			list = refOriginalList
		}
		if(refList) {
			cleanList = refList
		}
		let id, parentID, maxLevel

		if(utils.collectionSize(resourceData) === 0){
			return cleanList
		}

		for(const entry of resourceData || []){
			id = entry.attributes[entry.primaryKey || 0];
			parentID = entry.attributes[parentIDKey] || 0;
			list[id] = {
				children: {},
				parents: {},
				levels: {},
				levelDiff: {}
			};
			list[id].parents[parentID] = 1
			list[id].levelDiff[1] = parentID
		}

		for(const entry of resourceData || []){
			id = entry.attributes[entry.primaryKey]
			parentID = entry.attributes[parentIDKey]
			utils.prepareParent(list, id, parentID)
		}

		for(const [elementID, element] of Object.entries(list || {})){
			maxLevel = (element.parents || {})[0]
			utils.forEachReverse(element.levelDiff || {}, function(parentID, levelDiff){
				list[elementID].levels[maxLevel - levelDiff] = parseInt(parentID)
			})

			cleanList[elementID] = list[elementID].levels
		}

		return cleanList
	},

	/**
	 * this is a recursive helper function of prepareListOfParents and collects all
	 * information needed to build a list of entities and their parents.
	 *
	 * @param list			object - referential list of entities
	 * @param id			Mixed - id of entity
	 * @param parentID		Mixed - parentID of entity
	 * @param levelDiff		Integer - level difference counter used for function internal purposes only.
	 */
	prepareParent: function(list, id, parentID, levelDiff){
		if(!list[id]){
			list[id] = { children: {}, parents: {}, levels: {}, levelDiff: {} }
		}
		if(!levelDiff){
			levelDiff = 1
		}
		if(parentID){
			if(!list[parentID]){
				list[parentID] = { children: {}, parents: {}, levels: {}, levelDiff: {} }
			}

			list[parentID].children[id] = 1
			list[id].parents[parentID] = levelDiff
			list[id].levelDiff[levelDiff] = parentID

			for(const pID in (list[parentID] || {}).parents || {}){
				utils.prepareParent(list, id, pID, levelDiff + 1)
			}
		}
	},

	/**
	 * sorts resources' data list according to a tree sort defined by parentIDKey and sortKey
	 *
	 * @params 	refResources		{ data: [...] } - resources
	 * @params 	parentIDKey			string - fieldname of parentID attribute
	 * @params 	[refParents]		list of entities' parents per level
	 * @params 	[sortKey]			string - fieldname of sort attribute
	 */
	sortTreeResources: function(refResources, parentIDKey, refParents, sortKey){
		// init
		if(!(refResources || {}).data) return false;
		if(!sortKey) sortKey = 'sort';

		var entityParentsPerLevel = {};
		if(refParents) entityParentsPerLevel = refParents;
		var entity;
		var entities = {};
		var entityAttributes, entityID;

		// prepare list of parents
		utils.prepareListOfParents(refResources.data, parentIDKey, entityParentsPerLevel);

		// create a list of entities per menu-item (categoryData)
		for(var entityIndex in refResources.data || []){
			entity = refResources.data[entityIndex];

			entityAttributes = entity.attributes || {};
			entityID = entityAttributes[entity.primaryKey];
			entities[entityID] = entity;
		}

		// prepare sortKeys which are valid across the whole entityTree
		for(var entityID in entityParentsPerLevel){
			var entityLevels = entityParentsPerLevel[entityID];
			if(entities[entityID]){
				entities[entityID].sortKey = [];
				entities[entityID].realLevel = utils.collectionSize(entityLevels);
				entities[entityID].level = entities[entityID].realLevel;
				for(var level in entityLevels){
					var parentEntityID = entityLevels[level];

					// level 0 means root (virtual root of all nodes)
					if(level > 0 && (entities[parentEntityID] || {}).attributes){
						entities[entityID].sortKey.push(String(entities[parentEntityID].attributes[sortKey]).padStart(16, '0'));
					}
				}
				entities[entityID].sortKey.push(String(((entities[entityID] || {}).attributes || {})[sortKey] || 'UNKNOWN-OWN-SORT-KEY').padStart(16, '0'));
				entities[entityID].sortKey = entities[entityID].sortKey.join('-');
			}
		}

		// sort entities
		refResources.data.sort(function(a, b){
			if(a.sortKey < b.sortKey) return -1;
			if(a.sortKey === b.sortKey) return 0;
			return 1;
		});

		return true;
	},

	/**
	 * prepares a cms_category into an object of the following format: {<value>: <trlName>}
	 *
	 * @param storage				object - actual storage
	 * @param refResourceData		resourceData
	 * @param [langCode]			overrides langCode from storage if needed
	 * @returns {{}}
	 */
	categoriesToSimpleCategoryDataObject: function(storage, refResourceData, langCode){
		langCode = langCode || (storage || {}).langCode || 'de-at'

		const result = {}
		for(const catData of (((((refResourceData || {}).data || [])[0] || {}).children || {}).catData || {}).data || []){
			let value = (catData.attributes || {}).value
			let name = value
			for(const trl of (((catData || {}).children || {}).cms_categoriesDataTrl || {}).data || []){
				if((trl.attributes || {}).langCode === langCode){
					name = trl.attributes.name
				}
			}

			result[value] = name
		}

		return result
	},


	///////////////////////////////////////////////
	///// STRING HELPERS
	///////////////////////////////////////////////

	/**
	 * this function is used to return the given text with the first letter being transformed to uppercase.
	 *
	 * @param 	text		string - text
	 * @returns string - text upperCaseFirstLetter
	 */
	ucFirst: function(text){
		return typeof(text) === 'string' && text != '' ? text.charAt(0).toUpperCase() + text.slice(1) : '';
	},

	/**
	 * this function returns a human readable key according to the given value.
	 *
	 * @param 		value		string - value
	 * @returns		string - key
	 */
	getKeyFromValue: function(value){
		return (value || '').replace(/[^0-9a-zA-Z]+/g, '-');
	},

	///////////////////////////////////////////////
	///// ERROR HELPERS
	///////////////////////////////////////////////

	/**
	 * this function is used to extract as exact as possible the base error out of childErrors and cascading errors.
	 *
	 * @param   error       object - error
	 * @return  {} - baseError or given error if no baseError has been found
	 */
	extractBaseError: function(error){
		if(!this.isEmpty(error) && this.isCollection(error)){
			if(!utils.isEmpty(error.childErrors) && Array.isArray(error.childErrors)){
				return this.extractBaseError(error.childErrors[0]);
			}
			else if(!utils.isEmpty(error.error) && utils.isCollection(error.error)){
				return this.extractBaseError(error.error);
			}
			else {
				if(error.code && !error.errorCode)      error.errorCode = error.code;
				if(error.status && !error.statusCode)   error.statusCode = error.status;
			}
		}

		return error;
	},

	/**
	 * this function returns true if the given error is an error which has been thrown because of an invalid user, not logged in user or user with insufficient rights.
	 *
	 * @param 		error		object - error object
	 * @returns 	boolean
	 */
	isLoggedInError: function(error){
		return (
			error
			&&
			error.statusCode == 403
			&&
			(
				error.errorCode === 'API_PRIVILEGE_ERROR_1'
				||
				error.errorCode === 'API_PRIVILEGE_ERROR_2'
				||
				error.errorCode === 'API_PRIVILEGE_ERROR_3'
				||
				error.errorCode === 'API_PRIVILEGE_ERROR_4'
				||
				error.errorCode === 'API_PRIVILEGE_ERROR_5'
			)
		);
	},



	///////////////////////////////////////////////
	///// DOM HELPERS
	///////////////////////////////////////////////

	dom: {
		getHtmlFieldValue: function(fieldType, target){
			switch(fieldType){
				case 'text':
				case 'textarea':
				case 'select':
				case 'radio':
					return target.value;
					break;

				case 'checkbox':
					return ((!!target.checked) * 1);
					break;
			}
		},

       /**
        * get anchor identifier for html attribute "id".
        *
        * @param key            string - element's unique key.
        * @param [title]       	string - element's title for bots and search engines.
        * @return string anchor
        */
		getAnchorID: function(key, title = ''){
            if(!key){
                console.error(`utils.dom.getAnchorID() - Anchors without keys lack of purpose don't they?`);
                return false;
            }

            if(title){
                // this regex has to work in postgres prepare menu resources as well
                title = `${
					String(title || '')
						.toLowerCase()
						.replace(/ä/g, 'ae')
						.replace(/ö/g, 'oe')
						.replace(/ü/g, 'ue')
						.replace(/ß/g, 'ss')

						.replace(/[^a-z0-9_]+/g,'-')
				}`
            }

            return `${title}_a${key}`;
		}
	},



	///////////////////////////////////////////////
	///// SERVER HELPERS
	///////////////////////////////////////////////

	/**
	 * this function is used to get the domain out of the express-request-host header
	 *
	 * @param   host        string - express-request-host
	 * @returns             string - domain
	 */
	hostToDomain: function(host){
		const matches = String(host || '').match(/^(\s*https?:?\/\/)?([^:]+)(:[^:/]+)?$/)
		if(matches !== null && matches[2]){
			return matches[2]
		}
		return host
	},

	/**
	 * this function is used to generate the sitemap according to the given routes
	 *
	 * @param storage           	object - actual storage
	 * @param routes            	object - list of routes with routeID as keys
	 * @param refreshTS         	string - timestamp in ISO-8601 which should be used for lastModifiedTS
	 * @param baseUrl           	string - baseUrl which should be used for locations
	 * @param stream           		writeStream - stream the sitemap xml lines should be written to.
	 * @param [writeHeader=true]	boolean - write sitemap header
	 * @param [writeFooter=true]	boolean - write sitemap footer
	 */
	writeSiteMapXML: function(storage, routes, refreshTS, baseUrl, stream, writeHeader = true, writeFooter = true){
		var r, route, priority;
		var langCode, connectedRoute, connectedRoutes;
		if(!baseUrl || !stream) return;

		if(writeHeader) stream.write(SITEMAP_HEADER);

		for(r in routes){
			route = routes[r];
			if(route.isHome){
				priority = 1;
			}
			else {
				priority = Math.round((0.9 / Math.max(1, route.depth + 1)) * 1000) / 1000;
			}

			connectedRoutes = []
			for(langCode in route.routeLanguageConnections || {}){
				connectedRoute = route.routeLanguageConnections[langCode] || {};
				if(connectedRoute.path){
					connectedRoutes.push(`<xhtml:link rel="alternate" hreflang="${langCode}" href="${baseUrl + connectedRoute.path}" />`)
				}
			}

			stream.write(`<url><loc>${baseUrl + route.path}</loc>${connectedRoutes.join('')}<priority>${priority}</priority><lastmod>${route.lastChange || refreshTS}</lastmod><changefreq>weekly</changefreq></url>`)
		}

		if(writeFooter) stream.write(SITEMAP_FOOTER);
	},

	/**
	 * this function sanitizes the given requestedServiceCode according to the actual service config.
	 * if a service is not assigned it defaults to "undefined" which means the request uses the own service for data handling.
	 * this way a web-service may load categories from its cms via field.config.fecRequestedService = "cms" which would not work within the cms of this project, because the project cms has no assigned service named "cms".
	 * in this special case it would return undefined which leads to the project-cms using its own data anyway.
	 *
	 * @param storage							object - actual storage
	 * @param requestedServiceCode  			string | boolean - false => ownService, true => webService, string => requestedServiceCode within assignedServices.
	 * @param defaultRequestedServiceCode    	string - requestedServiceCode within assignedServices.
	 * @returns {*|string}
	 */
	sanitizeRequestedServiceCode: function(storage, requestedServiceCode, defaultRequestedServiceCode = 'web'){
		if(requestedServiceCode === false){
			return requestedServiceCode
		}
		if(requestedServiceCode && ((((storage || {}).app || {}).service || {}).grantedServiceUsage || {})[requestedServiceCode]){
			return requestedServiceCode
		}
		return defaultRequestedServiceCode
	},

	/**
	 * returns the requested service if possible and the actual service otherwise.
	 *
	 * @param storage				object - actual storage
	 * @param requestedServiceCode  string | boolean - false => ownService, true => webService, string => requestedServiceCode within assignedServices.
	 * @returns {*}
	 */
	getRequestedService(storage, requestedServiceCode = false){
		requestedServiceCode = utils.sanitizeRequestedServiceCode(storage, requestedServiceCode)
		const service = ((storage || {}).app || {}).service
		if(requestedServiceCode){
			return ((service || {}).assignedServices || {})[requestedServiceCode]
		}

		return service
	},



	///////////////////////////////////////////////
	///// ENVIRONMENT HELPERS
	///////////////////////////////////////////////

	environment: {

		/**
		 * return environment config according to the given requestedServiceCode.
		 *
		 * @param storage               object - actual storage
		 * @param requestedServiceCode 	string | boolean - false => ownService, true => webService, string => requestedServiceCode within assignedServices.
		 * @returns {{styles: *, style: *, layouts: {}}}
		 */
		getConfig(storage = null, requestedServiceCode = 'web'){
			requestedServiceCode = utils.sanitizeRequestedServiceCode(storage, requestedServiceCode)
			const service = ((storage || {}).app || {}).service || {}
			const requestedService = (service.assignedServices || {})[requestedServiceCode] || {}

			// use own filesystem config?
			// NOTE: if there is a difference between the own service and the requested one can not be determined by serviceID because the client does not know about such stuff.
			if(!storage || !requestedServiceCode || !service.url || service.url === requestedService.url){
				const serviceMediaConfig = (service.config || {}).media || {}
				const {
					styles  = serviceMediaConfig.styles,
					style   = serviceMediaConfig.style,
					layouts = serviceMediaConfig.layout || {},
				} = appConfig.environment || {}

				return {
					styles,
					style,
					layouts,
				}
			}

			// use requested service config
			// TODO: remove compatibility stuff after all services have been change to the new format.
			const requestedServiceMediaConfig = (requestedService.config || {}).media || {}
			const {
				styles  = requestedServiceMediaConfig.styles,
				style   = requestedServiceMediaConfig.style,
				layouts = requestedServiceMediaConfig.layout || {},
			} = ((requestedService.containerInfo || {}).config || {}).environment || {}

			return {
				styles,
				style,
				layouts,
			}
		},

		/**
		 * returns a list of strings (dom classes) used for html-body-tag based on the given environment
		 *
		 * @param environment		object - actual environment
		 * @returns {string[]}
		 */
		getBodyClasses(environment){
			environment = environment || {}

			const device = environment.device || {}
			const classes = []

			if(environment.style){
				classes.push(environment.style)
			}
			if(device.type){
				classes.push(`device-${device.type}`)
			}
			if(environment.breakPoint){
				classes.push(`breakPoint-${environment.breakPoint}`)
			}

			return classes
		},
	},

	keyboard: {
		// which keys are currently pressed
		activeKeyCodes: {},

		/**
		 * this function returns the code of a given keydown or keyup event.
		 * NOTE: the subset of supported keys is kept low sized on purpose.
		 *
		 * @param   event       Event - Dom-Key-Event
		 * @return  string      lower cased key code
		 */
		getKeyCode: function(event){
			if(event.which == 13)        return 'enter';
			else if(event.which == 27)   return 'esc';
			else if(event.which == 17)   return 'strg';

			return '';
		},

		/**
		 * this function is used to register a keyDown event identified by control key code
		 *
		 * @param keyCode       string - keyCode
		 */
		down: function(keyCode){
			if(keyCode) utils.keyboard.activeKeyCodes[keyCode] = true;
		},

		/**
		 * this function is used to register a keyUp event identified by control key code
		 *
		 * @param keyCode       string - keyCode
		 */
		up: function(keyCode){
			if(keyCode) utils.keyboard.activeKeyCodes[keyCode] = false;
		},

		/**
		 * this function is used to check if a control key code is currently pressed.
		 * NOTE: all arguments will be checked and corresponds to exactly one keyCode.
		 *
		 * @returns     boolean all keys given are pressed
		 */
		keysActive: function(){
			var k;
			var result = true;
			for(k in arguments){
				result &= utils.keyboard.activeKeyCodes[arguments[k]];
			}
			return result;
		}
	},



	///////////////////////////////////////////////
	///// LANGUAGE HELPERS
	///////////////////////////////////////////////

	language: {

		/**
		 * return a copy of the language config for the requestedServiceCode.
		 * if no storage or requestedServiceCode is given the actual containers language config will be returned.
		 *
		 * @param storage					object - actual storage
		 * @param requestedServiceCode  	string | boolean - false => ownService, true => webService, string => requestedServiceCode within assignedServices.
		 * @returns {{}} language config @see appConfig.language for details.
		 */
		getConfig(storage = null, requestedServiceCode = 'web'){
			const base = {
				default: 	'de-at',
				available: 	{},
				i18next: 	{},
			}
			requestedServiceCode = utils.sanitizeRequestedServiceCode(storage, requestedServiceCode)
			const service = ((storage || {}).app || {}).service || {}
			const requestedService = (service.assignedServices || {})[requestedServiceCode] || {}

			// use own filesystem config?
			// NOTE: if there is a difference between the own service and the requested one can not be determined by serviceID is the client does not know about such stuff.
			if(!storage || !requestedServiceCode || !service.url || service.url === requestedService.url){
				return {
					...base,
					...utils.simpleCopy(appConfig.language || {}),
				}
			}

			// use language config from filesystem of the requestedService
			const usedLanguageConfig = utils.simpleCopy(
				((requestedService.containerInfo || {}).config || {}).language
				||
				// TODO: remove this case after downwards compatibility is not necessary any longer
				// maybe let it stay here for when a web-container is offline e.g., when a project starts and the web-container has not been deployed yet.
				{
					available: (requestedService.config || {}).availableLangCodes || {},
				}
			)

			// if a container is not reachable at the moment it cannot deliver any containerInformation to the api.
			// in these cases a parent service (e.g., cms) has to assume a default config for its web container.
			if(utils.isEmpty(usedLanguageConfig.available)){
				usedLanguageConfig.available = {
					'de-at': {
						icon: 'flag-icon flag-icon-at',
						title: 'DE',
					}
				}
			}

			return {
				...base,
				...usedLanguageConfig,
			}
		},

		/**
		 * calls the given require function to obtain the translations for a language requirement (path to file using langCode and namespace).
		 * if the function throws an error it will be ignored.
		 *
		 * @param require		function - require callback
		 * @returns {{}} all loaded translations by langCode and namespace
		 */
		requireTranslations(require){
			const translations = {}
			for(const {langCode, namespace, requirement} of utils.language.eachRequirement()){
				try {
					translations[langCode] = translations[langCode] || {}
					translations[langCode][namespace] = require(requirement) || {}
				} catch(error){
					// ignore errors
				}
			}

			return translations
		},

		/**
		 * iterates over the actual containers appConfig.language.available options including their base languages (de-at and de)
		 *
		 * @returns {Generator<{langCode: string, namespace: string, requirement: string}, void, *>}
		 */
		*eachRequirement(){
			const {available, i18next: {ns}} = utils.language.getConfig()

			for(let langCode of Object.keys(available)){
				langCode = String(langCode || '').trim()
				if(!langCode){
					continue
				}
				const langCodes = [langCode]
				const [baseLang] = langCode.split('-')
				if(baseLang && baseLang !== langCode){
					langCodes.unshift(baseLang)
				}
				for(const lang of langCodes){
					for(const namespace of Object.values(ns)) {
						yield {
							langCode: 		lang,
							namespace,
							requirement: 	`./${lang}/${namespace}.js`
						}
					}
				}
			}
		},

		/**
		 * iterates over the actual containers appConfig.language.available options base languages (not de-at only de)
		 *
		 * @returns {Generator<string>}
		 */
		*eachSupportedBaseLangCode(){
			const {available} = utils.language.getConfig()

			for(let langCode of Object.keys(available)){
				langCode = String(langCode || '').trim()
				if(!langCode){
					continue
				}
				const [baseLang] = langCode.split('-')
				if(baseLang){
					yield baseLang
				}
			}
		},

		/**
		 * get base langCode form given langCode de-at => de
		 *
		 * @param langCode		string - langCode
		 * @returns {*}
		 */
		getBaseLangCode(langCode){
			return (String(langCode || '').trim().split('-') || [])[0]
		},
	},

	// TODO: remove this after downwards compatibility is not an issue any longer
	i18next: {
		/**
		 * @deprecated
		 */
		__: function(){
			return 'i18next does not life in utils any longer'
		}
	},



	///////////////////////////////////////////////
	///// MISCELANIOUS HELPERS
	///////////////////////////////////////////////

	// overridden in server/utils and client/utils!
	// md5: function(value){
	// ...
	// },
	moment,
	initMoment: function(momentConfig = {}){
		if(this.moment){
			const {
				timeZone,
				locale
			} = (momentConfig || {})
			this.moment.locale(locale)
			this.moment.tz.setDefault(timeZone)
			if((MomentRange || {}).extendMoment){
				MomentRange.extendMoment(this.moment)
			}
			this.moment = Object.freeze(this.moment)
			console.log('########### SET TIMEZONE: ' + (this.moment.defaultZone || {}).name + ' with locale ' + locale + ' ##############')
		}
	},

	/**
	 * moment rounds days which is not wanted sometimes.
	 *
	 * @param value	number
	 * @param unit string
	 * @returns {*}
	 */
	momentPreciseAdd: function(ts, value, unit){
		const m = utils.moment(ts)
		const numValue = value * 1
		if(value == numValue){
			const intValue = Math.round(numValue)
			const remainderValue = numValue - intValue
			if(value !== intValue && (unit === 'd' || unit === 'days')){
				return m
					.add(intValue, unit)
					.add(remainderValue * 24, 'hours')
			}
		}
		return m.add(value, unit)
	},

	date: {
		format: function(date, format){
			const m = moment(date)
			switch(format){
				case 'dbDateTime':
					return m.toISOString()

				case 'dbDate':
					return m.format('YYYY-MM-DD')

				default:
					return m.format(format || 'YYYY-MM-DD')
			}
		}
	},

	time: {
		diff: function(start, end){
			var s = utils.time.toMS(start || '');
			var e = utils.time.toMS(end || '');
			return e - s;
		},

		toMS: function(time){
			var parts = String(time || '').split(':');
			if(parts[2]){
				var sPart = String(parts[2] || '').split('.');
				parts[2] = sPart[0] || 0;
				parts[3] = sPart[1] || 0;
			}
			return (
				(((parts[0] * 1) || 0) * 3600000) +
				(((parts[1] * 1) || 0) * 60000) +
				(((parts[2] * 1) || 0) * 1000) +
				(((parts[3] * 1) || 0) * 1)
			);
		}
	},

	number: {
		format: function(value, format, fieldType = 'integer'){
			var originalValue = value;
			format = format || {}

			// default-config
			var conf = {
				locale: "de-DE",
				decimals: 0,
				decimalDigit: ",",
				thousandsDigit: "."
			};

			if(fieldType === 'float') {
				conf.decimals = 2;
			}

			if (format.locale !== undefined)			conf.locale = format.locale;
			if (format.decimals !== undefined)			conf.decimals = format.decimals;
			if (format.decimalDigit !== undefined)		conf.decimalDigit = format.decimalDigit;
			if (format.thousandsDigit !== undefined)	conf.thousandsDigit = format.thousandsDigit;

			// remove thousand-separator and replace decimal-point if input type is string (value is given formatted)
			if(typeof value === 'string'){
				value = value.replace(/^[^\d.,-]+/, '').replace(/[^\d.,]+$/, '')

				if (conf.thousandsDigit === '.') 	value = value.replace(/\./g, '').replace(/,/g, '.');
				else 								value = value.replace(/,/g, '');
			}

			// TODO: parseInt vs decimals > 0?
			if(fieldType === 'integer') {
				value = parseInt(value, 10)
			} else if(fieldType === 'float') {
				value = parseFloat(value)
			}

			if(format.changeValueGranted && (fieldType === 'integer' || fieldType === 'float')){
				if(format.factorToPercent === true && format.valueByUser){
					value /= 100
				}
				if(format.min !== undefined){
					value = Math.max(value, format.min)
				}
				if(format.max !== undefined){
					value = Math.min(value, format.max)
				}
				if(fieldType === 'float' && (format.decimals || format.factorToPercent === true)){
					let usedDecimals = format.decimals || 0
					if(format.factorToPercent === true){
						usedDecimals += 2
					}
					value = utils.number.round(value, usedDecimals)
				}
			}

			let formattedBaseValue = value
			if(format.factorToPercent === true && (fieldType === 'integer' || fieldType === 'float')){
				formattedBaseValue *= 100
			}

			var formatted = new Intl.NumberFormat(conf.locale, { minimumFractionDigits: conf.decimals, maximumFractionDigits: conf.decimals }).format(formattedBaseValue)
			formatted = `${format.prefix || ''}${formatted}${format.suffix || ''}`

			return {
				originalValue,
				value,
				formatted
			};
		},

		/**
		 * round via precision
		 *
		 * @param number		not null value
		 * @param precision		number of granted decimals between -300 and 300.
		 * @returns {number|null}
		 */
		round(number, precision = 0){
			if(number === null) return null;

			if(typeof number !== 'number'){
				number = Number(number || 0)
			}

			// MIN: Equal to approximately 5.00E-324. */
			// MAX: Equal to approximately 1.79E+308. */
			precision = Math.max(Math.min(precision, 300), -300)

			let factor = 1
			if(precision){
				factor = Math.pow(10, precision)
			}
			return Math.round(number * factor) / factor
		},

		/**
		 * parses some value into a float and returns the isNaNValue in case of the parsed result isNaN.
		 *
		 * @param value			mixed - value to parse
		 * @param isNaNValue	fallback value
		 */
		parseFloat(value, isNaNValue = undefined){
			const result = parseFloat(value)
			if(isNaN(result)){
				return isNaNValue
			}
			return result
		},

		/**
		 * parses some value into an integer and returns the isNaNValue in case of the parsed result isNaN.
		 *
		 * @param value            mixed - value to parse
		 * @param isNaNValue    fallback value
		 */
		parseInt(value, isNaNValue = 0){
			const result = parseInt(value)
			if(isNaN(result)){
				return isNaNValue
			}
			return result
		},
	},

	chart: {

		/**
		 * normalize (distort) number of elements within stats so users can see tiny fractions of elements within a chart.
		 *
		 * @param stats						object - list of stats to be prepared for a chart.
		 * @param [relativeMinClassWidth]	number - from 0 to 1. will be calculated automatically if undefined. describes the relative class width an element > 0 should be set to at least,
		 * @returns {{original: {absolute: {}, relative: {}}, normalized: {absolute: {}, relative: {}}, nrOfElements: number, sum: number}}
		 */
		normalizeClasses(stats, relativeMinClassWidth){
			// init
			const result = {
				nrOfElements: Object.values(stats || {}).length,
				sum: 0,
				original: {
					absolute: utils.map(stats || {}, value => utils.number.parseFloat(value, 0)),
					relative: {},
				},
				normalized: {
					absolute: {},
					relative: {},
				},
			}

			// base case
			if(result.nrOfElements < 1){
				return result
			}

			// calculate useful value for relativeMinClassWidth if necessary
			if(relativeMinClassWidth === undefined){
				relativeMinClassWidth = 1 / result.nrOfElements / 10
			}

			// one can't remove too much from too few elements
			if(result.nrOfElements >= (1 / relativeMinClassWidth)){
				console.error(new Error('nrOfElements too low. maybe try a smaller relativeMinClassWidth next time.'))
				return result
			}

			// sum
			for(const value of Object.values(stats)){
				result.sum += value
			}

			// base case
			if(result.sum <= 0){
				result.original.relative 	= result.original.absolute
				result.normalized.absolute 	= result.original.absolute
				result.normalized.relative 	= result.original.absolute

				return result
			}

			// calculate relative values
			for(const key in stats) {
				result.original.relative[key] = stats[key] / result.sum
			}

			// base case
			if(relativeMinClassWidth <= 0){
				result.normalized.absolute = result.original.absolute
				result.normalized.relative = result.original.relative

				return result
			}

			// remove as much delta from as many elements as possible so the smaller ones can reach the relativeMinClassWidth.
			// in case an element would get below the relativeMinClassWidth by subtracting the actual delta
			// the process has to be repeated with a bigger delta.
			let nrOfMinClassWidthElements = result.nrOfElements
			let normalizedRelativeSum = 1
			let delta, actualRelativeMinClassWidth, normalizedRelativeDiff = 0
			for(let i = 0; i < result.nrOfElements; i++){
				delta = normalizedRelativeDiff / nrOfMinClassWidthElements
				normalizedRelativeSum = 0
				nrOfMinClassWidthElements = 0
				actualRelativeMinClassWidth = relativeMinClassWidth + delta

				for(const key in stats){
					if(result.original.relative[key] > 0){
						if(result.original.relative[key] >= relativeMinClassWidth){
							if(result.original.relative[key] < actualRelativeMinClassWidth){
								result.normalized.relative[key] = result.original.relative[key]
							} else {
								nrOfMinClassWidthElements++
								result.normalized.relative[key] = result.original.relative[key] - delta
							}
						} else {
							result.normalized.relative[key] = relativeMinClassWidth
						}
					} else {
						result.normalized.absolute[key] = 0
						result.normalized.relative[key] = 0
					}

					normalizedRelativeSum += result.normalized.relative[key]
				}

				// stop if target values reached
				if(normalizedRelativeSum <= 1 || nrOfMinClassWidthElements < 1){
					break
				}

				// calculate the missing difference only once
				if(i < 1){
					normalizedRelativeDiff = normalizedRelativeSum - 1
				}
			}

			// if there is no normalizedRelativeSum matching the given criteria.
			if(normalizedRelativeSum > 1){
				result.normalized.absolute = result.original.absolute
				result.normalized.relative = result.original.relative

				console.warn(new Error('normalizedRelativeSum too big. maybe try a smaller relativeMinClassWidth next time.'))
				return result
			}

			// if not a single element reaches beyond the relativeMinClassWidth the data is too distorted to be shown to anyone.
			if(nrOfMinClassWidthElements < 1){
				result.normalized.absolute = result.original.absolute
				result.normalized.relative = result.original.relative

				console.error(new Error('nrOfMinClassWidthElements too small. maybe try a smaller relativeMinClassWidth next time.'))
				return result
			}

			// calculate normalized absolute values
			for(const key in stats){
				result.normalized.absolute[key] = result.sum * result.normalized.relative[key]
			}

			return result
		},
	},

	fileSize: {

		/**
		 * transform a given fileSize to a human readable format.
		 *
		 * @param sizeInBytes			int - sizeInBytes
		 * @param fractionDigits		int - number of digits after comma
		 * @returns {string}			human readable fileSize
		 */
		format: function(sizeInBytes, fractionDigits){
			sizeInBytes = sizeInBytes || 0;
			var realSize, extension;

			if(sizeInBytes > 1099511627776){
				realSize = (sizeInBytes / 1125899906842624);
				extension = 'TB';
			} else if(sizeInBytes > 1073741824){
				realSize = (sizeInBytes / 1073741824);
				extension = 'GB';
			} else if(sizeInBytes > 1048576){
				realSize = (sizeInBytes / 1048576);
				extension = 'MB';
			} else if(sizeInBytes > 1024){
				realSize = (sizeInBytes / 1024);
				extension = 'KB';
			} else {
				realSize = sizeInBytes;
				extension = 'B';
			}

			return parseFloat(String(realSize || '0').trim().replace(/[^\d\.]/g, "")).toFixed(fractionDigits || 2).toString().replace('\.', ',').replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.') + ' ' + extension;
		}
	},

	/**
	 * this function is used to build an md5 hash of recursive (as well as non-recursive) collections.
	 * the values are sorted by keys in an alphanumeric way so order differences does not matter.
	 * arrays and objects (empty or not) are processed distinct.
	 * the given value may be any value possible (primitive as well as arrays or objects).
	 * keys and values are handled case-sensitive.
	 *
	 * examples:
	 * 		String == Integer values are handled equal.
	 * 		'null' vs null values are handled equal.
	 * 		'undefined' vs undefined values are handled equal.
	 * 		'true' vs true values are handled equal.
	 * 		'True' vs true values are handled distinct.
	 *
	 * @param value		mixed
	 * @return String(32) md5 hash identifying the object
	 */
	collectionMD5: function(value){

		// md5 simple values
		if (value === null) {
			return utils.md5('null');
		}
		if (typeof value !== 'object') {
			return utils.md5(value);
		}

		var newValue, i;
		// md5 array
		if (value instanceof Array) {
			var l;
			newValue = [];
			for (i = 0, l = value.length; i < l; i++) {
				if (value[i] === null) {
					newValue.push(i + ':null');
				} else if (typeof value[i] !== 'object') {
					newValue.push(i + ':' + value[i]);
				} else {
					newValue.push(i + ':' + utils.collectionMD5(value[i]));
				}
			}
			return utils.md5('a|' + newValue.join(';'));
		}

		// md5 object
		newValue = [];
		for (i in value) {
			if (value.hasOwnProperty(i)) {
				if (value[i] === null) {
					newValue.push(i + ':null');
				} else if (typeof value[i] !== 'object') {
					newValue.push(i + ':' + value[i]);
				} else {
					newValue.push(i + ':' + utils.collectionMD5(value[i]));
				}
			}
		}

		if(newValue.length > 0){
			newValue.sort(function(a, b){
				if(a < b) return 1;
				if(a > b) return -1;
				return 0;
			});
		}

		return utils.md5('o|' + newValue.join(';'));
	},

	truncateStringByBytes: truncateStringByBytes.bind(null, getLength),

	// kebabCase: function(input){
	// 	// 'use strict';
	// 	var KEBAB_REGEX = /[A-Z\u00C0-\u00D6\u00D8-\u00DE]/g;
	// 	// var REVERSE_REGEX = /-[a-z\u00E0-\u00F6\u00F8-\u00FE]/g;
	//
	// 	module.exports = exports = function kebabCase(str) {
	// 		return str.replace(KEBAB_REGEX, function (match) {
	// 			return '-' + match.toLowerCase();
	// 		});
	// },

	nameSeoToPath: function(input){
		// sanitize by "npm i sanitize-filename truncate-utf8-bytes lodash.kebabCase"
		if(!input) return '';

		return kebabCase(
			this.truncateStringByBytes(
				String(input)
					.toLowerCase()
					.replace(/ä/g, 'ae')
					.replace(/ö/g, 'oe')
					.replace(/ü/g, 'ue')
					.replace(/ß/g, 'ss')

					.replace(/[^a-z0-9_]+/g,'-')

					.replace(/[\/\?<>\\:\*\|"]/g, '')
					.replace(/[\x00-\x1f\x80-\x9f]/g, '')
					.replace(/^\.+$/, '')
					.replace(/^(con|prn|aux|nul|com[0-9]|lpt[0-9])(\..*)?$/i, '')
					.replace(/[\. ]+$/, '')
				, 255
			)
		);
	},

	/**
	 * trim given input just like _.trim does
	 *
	 * @param input				string - input
	 * @param characters		string - character to be removed
	 * @returns {string}
	 */
	trim: function(input, characters = ' '){
		const startRegex = new RegExp(`^[${characters}]+`, 'g')
		const endRegex = new RegExp(`[${characters}]+$`, 'g')

		return String(input || '')
			.replace(startRegex, '')
			.replace(endRegex, '')
	},

	/**
	 * update storage.request.minFuturePeriodChangeAt timestamp according to the list of timestamps given.
	 *
	 * @param storage		object - actual storage
	 * @param timestamps	{} || [] || string - list of isoTimestamps as array or object, or isoTimestamp
	 * 						NOTE: all given timestamps have to be isoTimestamps GMT for the simple comparison to work. e.g., 2023-12-12T15:00:23.010Z
	 * 						NOTE: empty elements will be ignored silently.
	 * 						NOTE: new Date() has to work with it.
	 */
	updateMinFuturePeriodChangeAt: function(storage, timestamps){
		if(!this.isFunction(((storage || {}).user || {}).getReferenceTS) || !(storage || {}).request) return;

		if(this.isCollection(timestamps)){
			if(!this.isArray(timestamps)){
				timestamps = Object.values(timestamps)
			}
		} else if (timestamps){
			timestamps = [timestamps]
		}

		let referenceTS = storage.user.getReferenceTS()

		let minTS, ts
		for(ts of timestamps){
			ts = new Date(ts).toISOString()
			if(ts && ts > referenceTS && (!minTS || ts < minTS)){
				minTS = ts
			}
		}

		if(minTS){
			storage.request.minFuturePeriodChangeAt = minTS;
		}
	},



	///////////////////////////////////////////////
	///// ERROR HELPERS
	///////////////////////////////////////////////

	error: {

		/**
		 * this function prepares a given error context into usable, consistent error data.
		 * translations, model data preparation, image preparation if possible, etc.
		 * since base translations are located in fec now, it would be nice if the error components (e.g., like /components/errors/errors or /components/base/errors/errors) use the same error keys as well.
		 * this is why this function should be used. less logic within error components and uniform translation keys.
		 *
		 * MARK: FEC_ERROR_COMPONENT_HANDLING
		 * renderHtmlWrapper- and simpleErrorFormat-flags are set to true if the error will be rendered by the server for a html-request.
		 * these are used to show a public visitor a simple full-page-error if something went wrong. like 404 page not found stuff.
		 *
		 * if an error gets handled via fecClient somewhat more detailed information is due.
		 * these are the cases like "action not found" or "you are not allowed to delete this image".
		 *
		 * furthermore, the calling component can be one of multiple flavours:
		 * 		- it may be a regular instance within the project's database.
		 * 			this way one could set custom contents like error message, image, erc.
		 * 			even different ones for different errors
		 * 		- it may be a simple ejs template rendered via server without any data apart from the given error itself.
		 * 			@see /server/app.js express error handler for details.
		 * 		- it may be the content of a modal instantiated by the fecClient via an error-action
		 *
		 * these multiple flavours are responsible for somewhat restricted styling possibilities.
		 * if ones project is just a simple website rendered by the server none of these extra cases matter and one can style the errorComponent relatively free from any conventions.
		 * in fecClient use-cases - that being a full-blown cms client app or a hybrid using the fecClient just in one particular route - however, all flavours have to be supported somehow.
		 * this is the reason why one might embrace the following style-guides anyway:
		 * 		- the div containing the error itself has the class "errors_errors" (this is the reason why even the base error component - usually "base_errors_errors" - uses "errors_errors")
		 * 		- the div/body wrapping an error (renderHtmlWrapper) has the class "errorContainer". this errorContainer is missing within a modal. keep that in mind writing your styles.
		 * 		- styles are located in a less file of the same name as the error components ejs file. this is useful if one wants to load the right styles via fec-webpack bundle and a custom one. so the error looks at least similar in the different flavours.
		 *
		 * @param errorComponentEJSLocals		object - ejs error component context. in ejs files this is called locals.
		 * @returns {{renderHtmlWrapper: boolean, simpleErrorFormat: boolean, errorCode: string, statusCode: number | string, errorType: string, subErrorType: string, title: string, subTitle: string, message: string, _image: object, image: object}}
		 */
		prepare(errorComponentEJSLocals){
			const {
				storage,
				config = {},
				model = {},
				resourceData: error = {},
				helpers,
			} = errorComponentEJSLocals

			const {
				renderHtmlWrapper,
				simpleErrorFormat,
			} = config

			let errorType = '', subErrorType = ''
			// use components fallback model fields
			let {
				title,
				subTitle,
				message,
				image,
				_image,
			} = model
			let {
				statusCode = 500,
				errorCode: originalErrorCode = 'all',
			} = error
			const errorCode = String(originalErrorCode || '').toLowerCase().replace(/_+/g, '-')
			let showErrorCode = ''

			// prepare simple error
			if(simpleErrorFormat){
				errorType = 'fallback'
				subErrorType = 'all'

				// use components 404 model fields
				if(statusCode == 404){
					errorType = 'notFound'
					// TODO: POIA lowercase
					if(errorCode === 'FILE_NOT_FOUND') {
						subErrorType = 'file';
					} else if(errorCode === 'PROXY_CACHE_FILE_WILL_BE_READY_SHORTLY'){
						subErrorType = 'proxyCacheFileYet';
					}
					;({
						title_404: 			title,
						subTitle_404: 		subTitle,
						message_404: 		message,
						image_404: 			image,
						_image_404: 		_image,
					} = model)
				}
				// use components client model fields
				else if(statusCode == 'clientError'){
					errorType = 'clientError'
					;({
						title_client: 		title,
						subTitle_client: 	subTitle,
						message_client: 	message,
						image_client: 		image,
						_image_client: 		_image,
					} = model)
				}

				// use base translations if nothing else is available
				if(!title)      title       = storage.__(`error:${errorType}.${subErrorType}.title`);
				if(!subTitle)   subTitle    = storage.__(`error:${errorType}.${subErrorType}.subTitle`);
				if(!message)    message     = `<p>${storage.__(`error:${errorType}.${subErrorType}.message`)}</p>`;
			}
			// prepare detailed error
			else {
				const {
					serviceID = '~',
					userID = '~',
					serviceUserID = '~',
				} = ((storage || {}).user || {}).data || {}
				showErrorCode = [
					[`S${serviceID}`, `U${userID}`, `SU${serviceUserID}`].join(' '),
					new Date().toISOString(),
					[statusCode, originalErrorCode].filter(value => !!value).join(' ')
				].join('<br>')

				title       = storage.__(`error:${statusCode}.${errorCode}.title`)
				subTitle    = storage.__(`error:${statusCode}.${errorCode}.subTitle`)
				message     = `<p>${storage.__(`error:${statusCode}.${errorCode}.message`)}</p>`
			}

			// prepare image if necessary
			if(image && _image && utils.isFunction((helpers || {}).detectRenderedImage)){
				image = (helpers.detectRenderedImage(image, _image) || {}).rendered || {}
			}

			// return result
			return {
				// control-flags
				renderHtmlWrapper,
				simpleErrorFormat,

				// error details for machines
				errorCode,
				statusCode,
				errorType,
				subErrorType,
				showErrorCode,

				// error details for humans
				title,
				subTitle,
				message,
				_image,
				image,
			}
		},
	},




	///////////////////////////////////////////////
	///// DEBUG HELPERS
	///////////////////////////////////////////////

	debug: {}
};

/**
 * this is the internal function used for referential simple copies made by utils.refSimpleCopy()
 *
 * @param refTarget			mixed - referenced target
 * @param value				mixed - value to copy
 * @param index				mixed - index in referential target to copy value to.
 * @returns {{}|Array|*}
 */
var refSimpleCopy = function(refTarget, value, index) {
	try {
		// copy simple value
		if (typeof value !== 'object' || value === null) {
			refTarget[index] = value;
			return;
		}

		var i;
		// copy array
		if (value instanceof Array) {
			var l;
			if(!(refTarget[index] instanceof Array)){
				refTarget[index] = [];
			}
			for (i = 0, l = value.length; i < l; i++) {
				refSimpleCopy(refTarget[index], value[i], i);
			}
			return;
		}

		// copy object
		if(!refTarget[index] || typeof refTarget[index] !== 'object'){
			refTarget[index] = {};
		}
		for (i in value) {
			if (value.hasOwnProperty(i)) {
				refSimpleCopy(refTarget[index], value[i], i);
			}
		}
	} catch (error) {
		throw new Error(error.message)
	}
};

// set up override elements to prevent client side errors
utils.debug.timeMeasurement = {
	forceRelationKey: '',
	set: function(){},
	toString: function(){}
}

module.exports = utils
